const pattern = {
  en: /\d{1,2}\/[A-Z]{6,6}\((N|E|P|T|R|S)\)\d{5,6}/,
  mm: /[၀-၉]{1,2}\/[က-အ]{3,3}\((နိုင်|ဧည့်|ပြု|သာသနာ|ယာယီ|စ)\)([၀-၉]{5,6}|[0-9]{5,6})/
};
function splitNrc(nrc) {
  const [stateNo, townshipCode, nrcType, nrcNumber] = nrc.replace("/", ",").replace("(", ",").replace(")", ",").split(",");
  return { stateNo, townshipCode, nrcType, nrcNumber };
}
const nrcTypes$1 = [
  {
    id: "td02i9-VCkVil1fS",
    name: {
      en: "N",
      mm: "\u1014\u102D\u102F\u1004\u103A"
    }
  },
  {
    id: "v9eS9ElCS9dw_vvy",
    name: {
      en: "E",
      mm: "\u1027\u100A\u1037\u103A"
    }
  },
  {
    id: "xujB8kn-uSOQkTBs",
    name: {
      en: "P",
      mm: "\u1015\u103C\u102F"
    }
  },
  {
    id: "N_xJUnlEQbrFZ7gy",
    name: {
      en: "T",
      mm: "\u101E\u102C\u101E\u1014\u102C"
    }
  },
  {
    id: "-H6LTNZhywXRp4AC",
    name: {
      en: "Y",
      mm: "\u101A\u102C\u101A\u102E"
    }
  },
  {
    id: "5u6NHDCpEowFaonY",
    name: {
      en: "S",
      mm: "\u1005"
    }
  }
];
const nrcStates$1 = [
  {
    id: "bTuNIfLfchNvk1N_",
    code: "KACHIN",
    number: {
      en: "1",
      mm: "\u1041"
    },
    name: {
      en: "KACHIN",
      mm: "\u1000\u1001\u103B\u1004\u103A"
    }
  },
  {
    id: "ta4SEQoCI0DVTK2T",
    code: "KAYAH",
    number: {
      en: "2",
      mm: "\u1042"
    },
    name: {
      en: "KAYAH",
      mm: "\u1000\u101A\u102C\u1038"
    }
  },
  {
    id: "1dzIVEs684iyjetc",
    code: "KAYIN",
    number: {
      en: "3",
      mm: "\u1043"
    },
    name: {
      en: "KAYIN",
      mm: "\u1000\u101B\u1004\u103A"
    }
  },
  {
    id: "aVHfHbYrrdNZu9bW",
    code: "CHIN",
    number: {
      en: "4",
      mm: "\u1044"
    },
    name: {
      en: "CHIN",
      mm: "\u1001\u103B\u1004\u103A\u1038"
    }
  },
  {
    id: "EbUz7oziqo6OB5pL",
    code: "SAGAING",
    number: {
      en: "5",
      mm: "\u1045"
    },
    name: {
      en: "SAGAING",
      mm: "\u1005\u1005\u103A\u1000\u102D\u102F\u1004\u103A\u1038"
    }
  },
  {
    id: "X8rt_XwuTgAggCju",
    code: "TANINTHARYI",
    number: {
      en: "6",
      mm: "\u1046"
    },
    name: {
      en: "TANINTHARYI",
      mm: "\u1010\u1014\u101E\u102C\u101B\u102E"
    }
  },
  {
    id: "zBMPM_jGuwbus35I",
    code: "BAGO",
    number: {
      en: "7",
      mm: "\u1047"
    },
    name: {
      en: "BAGO",
      mm: "\u1015\u1032\u1001\u1030\u1038"
    }
  },
  {
    id: "u431U0SGuX9lkur-",
    code: "MAGWAY",
    number: {
      en: "8",
      mm: "\u1048"
    },
    name: {
      en: "MAGWAY",
      mm: "\u1019\u1000\u103D\u1031\u1038"
    }
  },
  {
    id: "5PflwjWItczLTOof",
    code: "MANDALAY",
    number: {
      en: "9",
      mm: "\u1049"
    },
    name: {
      en: "MANDALAY",
      mm: "\u1019\u1014\u1039\u1010\u101C\u1031\u1038"
    }
  },
  {
    id: "uQgglJ-AhohYQJNB",
    code: "MON",
    number: {
      en: "10",
      mm: "\u1041\u1040"
    },
    name: {
      en: "MON",
      mm: "\u1019\u103D\u1014\u103A"
    }
  },
  {
    id: "OfeDuBL9FsUHKi8j",
    code: "RAKHINE",
    number: {
      en: "11",
      mm: "\u1041\u1041"
    },
    name: {
      en: "RAKHINE",
      mm: "\u101B\u1001\u102D\u102F\u1004\u103A"
    }
  },
  {
    id: "Zvxm3m8cAwCeDgz1",
    code: "YANGON",
    number: {
      en: "12",
      mm: "\u1041\u1042"
    },
    name: {
      en: "YANGON",
      mm: "\u101B\u1014\u103A\u1000\u102F\u1014\u103A"
    }
  },
  {
    id: "DZ1kOrvrt-7LntG4",
    code: "SHAN",
    number: {
      en: "13",
      mm: "\u1041\u1043"
    },
    name: {
      en: "SHAN",
      mm: "\u101B\u103E\u1019\u103A\u1038"
    }
  },
  {
    id: "tY793VdREy9r5xsl",
    code: "AYEYAWADY",
    number: {
      en: "14",
      mm: "\u1041\u1044"
    },
    name: {
      en: "AYEYAWADY",
      mm: "\u1027\u101B\u102C\u1040\u1010\u102E"
    }
  },
  {
    id: "sH0ybsmxNuxmeOT_",
    code: "NAYPYITAW",
    number: {
      en: "9*",
      mm: "\u1049*"
    },
    name: {
      en: "NAYPYITAW",
      mm: "\u1014\u1031\u1015\u103C\u100A\u103A\u1010\u1031\u102C\u103A"
    }
  }
];
const nrcTownships = [
  {
    id: "W_7wtdGa_p8AZ4hq",
    code: "HOPIN",
    short: {
      en: "HAPANA",
      mm: "\u101F\u1015\u1014"
    },
    name: {
      en: "HO PIN",
      mm: "\u101F\u102D\u102F\u1015\u1004\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "cAy7xIR6FwHJHMU8",
    code: "KANYEIKTI",
    short: {
      en: "KAPATA",
      mm: "\u1000\u1015\u1010"
    },
    name: {
      en: "KAN YEIK TI",
      mm: "\u1000\u1019\u103A\u1015\u1010\u102E"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "mKK_kRmtjzFCfaSZ",
    code: "KHAWBUDAE",
    short: {
      en: "KHABADA",
      mm: "\u1001\u1018\u1012"
    },
    name: {
      en: "KHAW BU DAE",
      mm: "\u1001\u1031\u102B\u103A\u1018\u1030\u1012\u1032"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "_XkhjBIER0i7APgS",
    code: "PHAKANT",
    short: {
      en: "PHAKANA",
      mm: "\u1016\u1000\u1014"
    },
    name: {
      en: "PHA KANT",
      mm: "\u1016\u102C\u1038\u1000\u1014\u1037\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "YwSNNC_QhN79Y_GM",
    code: "MACHANBAW",
    short: {
      en: "MAKHABA",
      mm: "\u1019\u1001\u1018"
    },
    name: {
      en: "MA CHAN BAW",
      mm: "\u1019\u1001\u103B\u1019\u103A\u1038\u1018\u1031\u102C"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "-PhegWB56SRfAvEI",
    code: "DOTPHONEYAN",
    short: {
      en: "DAPHAYA",
      mm: "\u1012\u1016\u101A"
    },
    name: {
      en: "DOT PHONE YAN",
      mm: "\u1012\u1031\u102B\u1037\u1016\u102F\u1014\u103A\u1038\u101A\u1014\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "vJ36EQIzjQ_pnWG-",
    code: "PANWAR",
    short: {
      en: "PAWANA",
      mm: "\u1015\u1040\u1014"
    },
    name: {
      en: "PANWAR",
      mm: "\u1015\u1014\u103A\u101D\u102B"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "U5DTeH4YCTY_UpVc",
    code: "PANNANDIN",
    short: {
      en: "PANADA",
      mm: "\u1015\u1014\u1012"
    },
    name: {
      en: "PAN NAN DIN",
      mm: "\u1015\u1014\u103A\u1014\u1014\u103A\u1038\u1012\u1004\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "aMI7h3E5rsntyvz9",
    code: "HSADONE",
    short: {
      en: "SADANA",
      mm: "\u1006\u1012\u1014"
    },
    name: {
      en: "HSA DONE",
      mm: "\u1006\u1012\u102F\u1036\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "6q4-EJQW_PHyAO5y",
    code: "BHAMO",
    short: {
      en: "BAMANA",
      mm: "\u1017\u1019\u1014"
    },
    name: {
      en: "BHA MO",
      mm: "\u1017\u1014\u103A\u1038\u1019\u1031\u102C\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "tj8uMpSgk3jLRH7r",
    code: "PHA KANT",
    short: {
      en: "KAMANA",
      mm: "\u1016\u1000\u1014"
    },
    name: {
      en: "PHA KANT",
      mm: "\u1016\u102C\u1038\u1000\u1014\u1037\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "ibqQAMqgkdONCc1n",
    code: "MANSI",
    short: {
      en: "MASANA",
      mm: "\u1019\u1005\u1014"
    },
    name: {
      en: "MAN SI",
      mm: "\u1019\u1036\u1005\u102E"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "JUC5--8SHHor8UKG",
    code: "LWEGE",
    short: {
      en: "LAGANA",
      mm: "\u101C\u1002\u1014"
    },
    name: {
      en: "LWE GE",
      mm: "\u101C\u103D\u101A\u103A\u1002\u1031"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "2g4sxriajpkYrdUd",
    code: "NAUNGMOON",
    short: {
      en: "NAMANA",
      mm: "\u1014\u1019\u1014"
    },
    name: {
      en: "NAUNG MOON",
      mm: "\u1014\u1031\u102C\u1004\u103A\u1019\u103D\u1014\u103A\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "NbbisKJ6cYqa4j5G",
    code: "MOMAUK",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MOE MAUK",
      mm: "\u1019\u102D\u102F\u1038\u1019\u1031\u102C\u1000\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "2xDUSYGUabM4IoOY",
    code: "KAMINE",
    short: {
      en: "KAMATA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KA MINE",
      mm: "\u1000\u102C\u1019\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "yuibWtL69cKVlr8G",
    code: "MOGAUNG",
    short: {
      en: "MAKATA",
      mm: "\u1019\u1000\u1010"
    },
    name: {
      en: "MO GAUNG",
      mm: "\u1019\u102D\u102F\u1038\u1000\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "MKSBi-k1gxTibOOA",
    code: "MOHNYIN",
    short: {
      en: "MANYANA",
      mm: "\u1019\u100A\u1014"
    },
    name: {
      en: "MOH NYIN",
      mm: "\u1019\u102D\u102F\u1038\u100A\u103E\u1004\u103A\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "qCWSDti9uzuir6_p",
    code: "CHIPHWE",
    short: {
      en: "KHAPHANA",
      mm: "\u1001\u1016\u1014"
    },
    name: {
      en: "CHI PHWE",
      mm: "\u1001\u103B\u102E\u1016\u103D\u1031"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "J3tWOGdc_oe1vO7A",
    code: "HSINBO",
    short: {
      en: "SABATA",
      mm: "\u1006\u1018\u1014"
    },
    name: {
      en: "SIN BO",
      mm: "\u1006\u1004\u103A\u1018\u102D\u102F"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "vg2dGu-Edn2Q99gF",
    code: "HSOTLAW",
    short: {
      en: "SALANA",
      mm: "\u1006\u101C\u1014"
    },
    name: {
      en: "SAW LAW",
      mm: "\u1006\u1031\u102C\u1037\u101C\u1031\u102C\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "RGWcrfF94mBI_-LC",
    code: "INGYANYAN",
    short: {
      en: "AHGAYA",
      mm: "\u1021\u1002\u101A"
    },
    name: {
      en: "ING YAN YAN",
      mm: "\u1021\u1004\u103A\u1002\u103B\u1014\u103A\u1038\u101A\u1014\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "9jKUg_YrVbtzcHSB",
    code: "MYITKYINA",
    short: {
      en: "MAKANA",
      mm: "\u1019\u1000\u1014"
    },
    name: {
      en: "MYIT KYI NA",
      mm: "\u1019\u103C\u1005\u103A\u1000\u103C\u102E\u1038\u1014\u102C\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "QzQngTsUPM6ktfmK",
    code: "SHINBWAYYAN",
    short: {
      en: "YABAYA",
      mm: "\u101B\u1018\u101A"
    },
    name: {
      en: "SHIN BWAY YAN",
      mm: "\u101B\u103E\u1004\u103A\u1018\u103D\u102E\u101A\u1014\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "WelAEipDPFdUMs78",
    code: "TANAING",
    short: {
      en: "TANANA",
      mm: "\u1010\u1014\u1014"
    },
    name: {
      en: "TA NAING",
      mm: "\u1010\u1014\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "ES5_U1I71DhYCmpK",
    code: "KHAUNGLANPHOO",
    short: {
      en: "KHALAPHA",
      mm: "\u1001\u101C\u1016"
    },
    name: {
      en: "KHAUNG LAN PHOO",
      mm: "\u1001\u1031\u102B\u1004\u103A\u101C\u1014\u103A\u1016\u1030\u1038"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "Pey_NLCfQOXz4qQG",
    code: "PUTAO",
    short: {
      en: "PATAAH",
      mm: "\u1015\u1010\u1021"
    },
    name: {
      en: "PU TA O",
      mm: "\u1015\u1030\u1010\u102C\u1021\u102D\u102F"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "yZyB719It-X-JD_X",
    code: "SUMPRABUM",
    short: {
      en: "SAPABA",
      mm: "\u1006\u1015\u1018"
    },
    name: {
      en: "SUM PRA BUM",
      mm: "\u1006\u103D\u1019\u103A\u1015\u101B\u102C\u1018\u103D\u1019\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "rsByqGuC2oGCHzHw",
    code: "SHWEGU",
    short: {
      en: "YAKANA",
      mm: "\u101B\u1000\u1014"
    },
    name: {
      en: "SHWE GU",
      mm: "\u101B\u103D\u103E\u1031\u1000\u1030"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "QjkdH9SEJlPIcceH",
    code: "WAINGMAW",
    short: {
      en: "WAMANA",
      mm: "\u1040\u1019\u1014"
    },
    name: {
      en: "WAING MAW",
      mm: "\u101D\u102D\u102F\u1004\u103A\u1038\u1019\u1031\u102C\u103A"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "-8Zyq0kGJcCly-ff",
    code: "MYOHLAMYO",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MYOHLAMYO",
      mm: "\u1019\u103C\u102D\u102F\u1037\u101C\u103E\u1019\u103C\u102D\u102F\u1037"
    },
    stateId: "bTuNIfLfchNvk1N_",
    stateCode: "1"
  },
  {
    id: "V7KfFkHzqmuQDsT1",
    code: "PARSAUNG",
    short: {
      en: "PHASANA",
      mm: "\u1016\u1006\u1014"
    },
    name: {
      en: "PAR SAUNG",
      mm: "\u1016\u102C\u1038\u1006\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "w-8IYr7okCPo_2GN",
    code: "PHRUSO",
    short: {
      en: "PHAYASA",
      mm: "\u1016\u101B\u1006"
    },
    name: {
      en: "PHRU SO",
      mm: "\u1016\u101B\u1030\u1038\u1006\u102D\u102F\u1038"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "512VwEQXJuCJ9Ey5",
    code: "BAWLAKHE",
    short: {
      en: "BALAKHA",
      mm: "\u1018\u101C\u1001"
    },
    name: {
      en: "BAW LA KHE",
      mm: "\u1018\u1031\u102C\u103A\u101C\u1001\u1032"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "Xz6HhRjc14_XT81P",
    code: "MEISI",
    short: {
      en: "MASANA",
      mm: "\u1019\u1005\u1014"
    },
    name: {
      en: "MEISI",
      mm: "\u1019\u101A\u103A\u1005\u102E"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "7n2jV5MTrmXYyvlE",
    code: "YWATHIT",
    short: {
      en: "YATHANA",
      mm: "\u101B\u101E\u1014"
    },
    name: {
      en: "YWATHIT",
      mm: "\u101B\u103D\u102C\u101E\u1005\u103A"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "xY6oWEw3GNrUMnO8",
    code: "LOIKAW",
    short: {
      en: "LAKANA",
      mm: "\u101C\u1000\u1014"
    },
    name: {
      en: "LOI KAW",
      mm: "\u101C\u103D\u102D\u102F\u1004\u103A\u1000\u1031\u102C\u103A"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "5Wf0UDGwPTlrg9VY",
    code: "SHARDAW",
    short: {
      en: "YATANA",
      mm: "\u101B\u1010\u1014"
    },
    name: {
      en: "SHAR DAW",
      mm: "\u101B\u103E\u102C\u1038\u1010\u1031\u102C\u103A"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "nNyti8Yxqtz53szX",
    code: "DIMAWSO",
    short: {
      en: "DAMASA",
      mm: "\u1012\u1019\u1006"
    },
    name: {
      en: "DI MAW SO",
      mm: "\u1012\u102E\u1019\u1031\u102C\u1006\u102D\u102F\u1038"
    },
    stateId: "ta4SEQoCI0DVTK2T",
    stateCode: "2"
  },
  {
    id: "mL56z6lD5fCD6DlG",
    code: "BAWGALI",
    short: {
      en: "BAKALA",
      mm: "\u1018\u1000\u101C"
    },
    name: {
      en: "BAW GA LI",
      mm: "\u1018\u1031\u102C\u1000\u101C\u102D"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "sw7fLrWawA6t8NZi",
    code: "THANDAUNGGYI",
    short: {
      en: "THATAKA",
      mm: "\u101E\u1010\u1000"
    },
    name: {
      en: "THAN DAUNG GYI",
      mm: "\u101E\u1036\u1010\u1031\u102C\u1004\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "iC5NX-QpfHox0VUg",
    code: "SUGALI",
    short: {
      en: "SAKALA",
      mm: "\u1005\u1000\u101C"
    },
    name: {
      en: "SU GA LI",
      mm: "\u1005\u102F\u1000\u101C\u102D"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "53OOlTy_ttH8RAT2",
    code: "WALEMYAING",
    short: {
      en: "WALAMA",
      mm: "\u1040\u101C\u1019"
    },
    name: {
      en: "WALE MYAING",
      mm: "\u1031\u1040\u102B\u101C\u1004\u103A\u1019\u103C\u102D\u102F\u1004\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "fA_IV-02Zg8Wd8v3",
    code: "BAW GA LI",
    short: {
      en: "BAGALA",
      mm: "\u1018\u1002\u101C"
    },
    name: {
      en: "BAW GA LI",
      mm: "\u1018\u1031\u102C\u103A\u1002\u101C\u102D"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "sI0SmL5VfRgHxmou",
    code: "KAWKAREIK",
    short: {
      en: "KAKAYA",
      mm: "\u1000\u1000\u101B"
    },
    name: {
      en: "KAW KA REIK",
      mm: "\u1000\u1031\u102C\u1037\u1000\u101B\u102D\u1010\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "GQY_uYyyGKMZmqb9",
    code: "PAINGKYON",
    short: {
      en: "PAKANA",
      mm: "\u1015\u1000\u1014"
    },
    name: {
      en: "PAING KYON",
      mm: "\u1015\u102D\u102F\u1004\u103A\u1000\u103B\u102F\u1036\u1038"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "yl4abNgJKsvQQ4OU",
    code: "HLAINGBWE",
    short: {
      en: "LABANA",
      mm: "\u101C\u1018\u1014"
    },
    name: {
      en: "HLAING BWE",
      mm: "\u101C\u103E\u102D\u102F\u1004\u103A\u1038\u1018\u103D\u1032\u1037"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "DzJikNhDk8BI9ti7",
    code: "HPA-AN",
    short: {
      en: "BAAHNA",
      mm: "\u1018\u1021\u1014"
    },
    name: {
      en: "HPA-AN",
      mm: "\u1018\u102C\u1038\u1021\u1036"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "yOXyuybt0xd7c31P",
    code: "LEIKTHO",
    short: {
      en: "LATHANA",
      mm: "\u101C\u101E\u1014"
    },
    name: {
      en: "LEIKTHO",
      mm: "\u101C\u102D\u1015\u103A\u101E\u102D\u102F"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "ngHF07USecW-Qt4P",
    code: "SHANYWATHIT",
    short: {
      en: "YAYATHA",
      mm: "\u101B\u101B\u101E"
    },
    name: {
      en: "SHAN YWA THIT",
      mm: "\u101B\u103E\u1019\u103A\u1038\u101B\u103D\u102C\u101E\u1005\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "xUfysVWy8Hkc9xz1",
    code: "KYAIDON",
    short: {
      en: "KADANA",
      mm: "\u1000\u1012\u1014"
    },
    name: {
      en: "KYAI DON",
      mm: "\u1000\u103B\u102F\u1036\u1012\u102D\u102F\u1038"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "HEt6V2wZjeSx3s6N",
    code: "KYARINSEIKKYI",
    short: {
      en: "KASAKA",
      mm: "\u1000\u1006\u1000"
    },
    name: {
      en: "KYAR IN SEIK KYI",
      mm: "\u1000\u103C\u102C\u1021\u1004\u103A\u1038\u1006\u102D\u1015\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "VfSJHkvNBd0ltQM2",
    code: "THANTAUNG",
    short: {
      en: "THATANA",
      mm: "\u101E\u1010\u1014"
    },
    name: {
      en: "THANTAUNG",
      mm: "\u101E\u1036\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "LRV3Buop3b0Z69LV",
    code: "PAYARTHONEZU",
    short: {
      en: "BATHASA",
      mm: "\u1018\u101E\u1006"
    },
    name: {
      en: "PA YAR THONE ZU",
      mm: "\u1018\u102F\u101B\u102C\u1038\u101E\u102F\u1036\u1038\u1006\u1030"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "XEusP7vrIsmq1uOn",
    code: "MYAWADY",
    short: {
      en: "MAWATA",
      mm: "\u1019\u101D\u1010"
    },
    name: {
      en: "MYA WA DY",
      mm: "\u1019\u103C\u101D\u1010\u102E"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "oMquaPZ-Uc31Hhbn",
    code: "KAMAMAUNG",
    short: {
      en: "KAMAMA",
      mm: "\u1000\u1019\u1019"
    },
    name: {
      en: "KA MA MAUNG",
      mm: "\u1000\u1019\u1019\u1031\u102C\u1004\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "i5eLS_GpQOipTmx_",
    code: "PHARPON-KAYIN",
    short: {
      en: "PHAPANA",
      mm: "\u1016\u1015\u1014"
    },
    name: {
      en: "PHARPON-KAYIN",
      mm: "\u1016\u102C\u1015\u103D\u1014\u103A"
    },
    stateId: "1dzIVEs684iyjetc",
    stateCode: "3"
  },
  {
    id: "hzqcOq54St_ybBFO",
    code: "PALETWA",
    short: {
      en: "PALAWA",
      mm: "\u1015\u101C\u101D"
    },
    name: {
      en: "PA LET WA",
      mm: "\u1015\u101C\u1000\u103A\u101D"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "M2O6RzO6lpSPguln",
    code: "CIKHA",
    short: {
      en: "KAKHANA",
      mm: "\u1000\u1001\u1014"
    },
    name: {
      en: "CIKHA",
      mm: "\u1000\u103B\u102E\u1001\u102B\u1038"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "crDH_EsA2PLyt6bL",
    code: "FALAM",
    short: {
      en: "PHALANA",
      mm: "\u1016\u101C\u1014"
    },
    name: {
      en: "FA LAM",
      mm: "\u1016\u101C\u1019\u103A\u1038"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "LeY1Rll3hJ3x_FCc",
    code: "TEDIM",
    short: {
      en: "TATANA",
      mm: "\u1010\u1010\u1014"
    },
    name: {
      en: "TEDIM",
      mm: "\u1010\u102E\u1038\u1010\u102D\u1014\u103A"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "5JuhhzYwRfjIHWt2",
    code: "TONZAUNG",
    short: {
      en: "TAZANA",
      mm: "\u1010\u1007\u1014"
    },
    name: {
      en: "TON ZAUNG",
      mm: "\u1010\u103D\u1014\u103A\u1038\u1007\u1036"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "pDbUU8bOj-7Xf5jM",
    code: "MATUPI",
    short: {
      en: "MATAPA",
      mm: "\u1019\u1010\u1015"
    },
    name: {
      en: "MA TU PI",
      mm: "\u1019\u1010\u1030\u1015\u102E"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "XEg2ZWYrZF40CkBE",
    code: "MINDAT",
    short: {
      en: "MATANA",
      mm: "\u1019\u1010\u1014"
    },
    name: {
      en: "MINDAT",
      mm: "\u1019\u1004\u103A\u1038\u1010\u1015\u103A"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "9D4N0ndMiSebAJgW",
    code: "SAMI",
    short: {
      en: "SAMANA",
      mm: "\u1006\u1019\u1014"
    },
    name: {
      en: "SAMI",
      mm: "\u1005\u1019\u102E\u1038"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "du3_6nkkO30kM4k3",
    code: "KANPALET",
    short: {
      en: "KAPALA",
      mm: "\u1000\u1015\u101C"
    },
    name: {
      en: "KAN PA LET",
      mm: "\u1000\u1014\u103A\u1015\u1000\u103A\u101C\u1000\u103A"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "7s8T3BMNfJaEyxsY",
    code: "RIHKHUADAL",
    short: {
      en: "YAKHADA",
      mm: "\u101B\u1001\u1012"
    },
    name: {
      en: "RIH KHUA DAL",
      mm: "\u101B\u1001\u1030\u1038\u1012\u1032"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "7QyePxaRYn8xT47x",
    code: "HAKA",
    short: {
      en: "HAKHANA",
      mm: "\u101F\u1001\u1014"
    },
    name: {
      en: "HAKA",
      mm: "\u101F\u102C\u1038\u1001\u102B\u1038"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "EIz_tVK6aZTDM-n3",
    code: "HTANTALANG",
    short: {
      en: "HTATALA",
      mm: "\u1011\u1010\u101C"
    },
    name: {
      en: "HTAN TA LANG",
      mm: "\u1011\u1014\u103A\u1010\u101C\u1014\u103A"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "7n1zhWPjs-CRI5Gt",
    code: "YAYSWAR",
    short: {
      en: "YAZANA",
      mm: "\u101B\u1007\u1014"
    },
    name: {
      en: "YAYSWAR",
      mm: "\u101B\u1031\u1007\u103D\u102C"
    },
    stateId: "aVHfHbYrrdNZu9bW",
    stateCode: "4"
  },
  {
    id: "JhgQlvV0F6yjfxuj",
    code: "PINLEBU",
    short: {
      en: "PALABA",
      mm: "\u1015\u101C\u1018"
    },
    name: {
      en: "PIN LE BU",
      mm: "\u1015\u1004\u103A\u101C\u101A\u103A\u1018\u1030\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "mjFI1i0HGAlgzjGK",
    code: "PANSAUNG",
    short: {
      en: "PASANA",
      mm: "\u1015\u1006\u1014"
    },
    name: {
      en: "PANSAUNG",
      mm: "\u1015\u1014\u103A\u1006\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "vRiPXJmJ-OfP6wAV",
    code: "AYARTAW",
    short: {
      en: "AHYATA",
      mm: "\u1021\u101B\u1010"
    },
    name: {
      en: "A YAR TAW",
      mm: "\u1021\u101B\u102C\u1010\u1031\u102C\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "4F67ogW_s-niHErq",
    code: "KHAMPAT",
    short: {
      en: "KHAPANA",
      mm: "\u1001\u1015\u1014"
    },
    name: {
      en: "KHAM PAT",
      mm: "\u1001\u1019\u103A\u1038\u1015\u1010\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "LY7MoRt2PTd9fbdi",
    code: "KYAUKMYAUNG-SAGAING",
    short: {
      en: "KAMANA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KYAUKMYAUNG-SAGAING",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1019\u103C\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "yTgN79JQOvg8XOUO",
    code: "MYOTHIT-SAGAING",
    short: {
      en: "MATHANA",
      mm: "\u1019\u101E\u1014"
    },
    name: {
      en: "MYO THIT-SAGAING",
      mm: "\u1019\u103C\u102D\u102F\u1037\u101E\u1005\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "g_1mgcXHtsujek_q",
    code: "HOMALIN",
    short: {
      en: "HAMALA",
      mm: "\u101F\u1019\u101C"
    },
    name: {
      en: "HO MA LIN",
      mm: "\u101F\u102F\u1019\u1039\u1019\u101C\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "wJBGcj1QJ8oDi_IH",
    code: "BANMAUK",
    short: {
      en: "BAMANA",
      mm: "\u1017\u1019\u1014"
    },
    name: {
      en: "BAN MAUK",
      mm: "\u1017\u1014\u103A\u1038\u1019\u1031\u102C\u1000\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "P8WRYnOsZYAbY9fB",
    code: "MYAUNG",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MYAUNG",
      mm: "\u1019\u103C\u1031\u102C\u1004\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "RQlhceAep1VXf-Pu",
    code: "SALINGYI",
    short: {
      en: "SALAKA",
      mm: "\u1006\u101C\u1000"
    },
    name: {
      en: "SA LIN GYI",
      mm: "\u1006\u102C\u1038\u101C\u1004\u103A\u1038\u1000\u103C\u102E\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "vvXeYDWCXWhxx11v",
    code: "NGANZUN",
    short: {
      en: "NGAZANA",
      mm: "\u1004\u1007\u1014"
    },
    name: {
      en: "NGAN ZUN",
      mm: "\u1004\u102B\u1014\u103A\u1038\u1007\u103D\u1014\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "iFI9Mqtoo4OWtjW6",
    code: "YEU",
    short: {
      en: "YAOUNA",
      mm: "\u101B\u1025\u1014"
    },
    name: {
      en: "YE U",
      mm: "\u101B\u1031\u1026\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "k2QCAkYMe2UQ__Fh",
    code: "KALAY",
    short: {
      en: "KALAHTA",
      mm: "\u1000\u101C\u1011"
    },
    name: {
      en: "KA LAY",
      mm: "\u1000\u101C\u1031\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "wsjC90s0uT5orvQw",
    code: "YWATHITGYI",
    short: {
      en: "YATHAKA",
      mm: "\u101B\u101E\u1000"
    },
    name: {
      en: "YWA THIT GYI",
      mm: "\u101B\u103D\u102C\u101E\u1005\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "FWm8GYPBQ3ErNORF",
    code: "SWAMMARA",
    short: {
      en: "HSAMARA",
      mm: "\u1006\u1019\u101B"
    },
    name: {
      en: "SWAMMARA",
      mm: "\u1006\u103D\u1019\u1039\u1019\u101B\u102C"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "OWv56MGVrX7XGOwS",
    code: "SAGAING",
    short: {
      en: "SAKANA",
      mm: "\u1005\u1000\u1014"
    },
    name: {
      en: "SA GAING",
      mm: "\u1005\u1005\u103A\u1000\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "-JDGUjHFP0ed6v5O",
    code: "MAWLAIK",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MAWLAIK",
      mm: "\u1019\u1031\u102C\u103A\u101C\u102D\u102F\u1000\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "Alsd1ObVlnrxOqrJ",
    code: "YINMARPIN",
    short: {
      en: "YAMAPA",
      mm: "\u101A\u1019\u1015"
    },
    name: {
      en: "YIN MAR PIN",
      mm: "\u101A\u1004\u103A\u1038\u1019\u102C\u1015\u1004\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "IAUnGPwR027W2_wL",
    code: "KAWLIN",
    short: {
      en: "KALATA",
      mm: "\u1000\u101C\u1010"
    },
    name: {
      en: "KAWLIN",
      mm: "\u1000\u1031\u102C\u101C\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "dBAb82g6xMcStYau",
    code: "KYUNHLA",
    short: {
      en: "KALANA",
      mm: "\u1000\u101C\u1014"
    },
    name: {
      en: "KYUNHLA",
      mm: "\u1000\u103B\u103D\u1014\u103A\u1038\u101C\u103E"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "YvNu1EdzE9wYxnFK",
    code: "HKAMTI",
    short: {
      en: "KHATANA",
      mm: "\u1001\u1010\u1014"
    },
    name: {
      en: "HKAMTI",
      mm: "\u1001\u1014\u1039\u1010\u102E\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "Pzr_A68MOEgSPA21",
    code: "HTANPARKWAY",
    short: {
      en: "HTAPAKHA",
      mm: "\u1011\u1015\u1001"
    },
    name: {
      en: "HTAN PAR KWAY",
      mm: "\u1011\u1014\u103A\u1015\u102B\u1001\u103D\u1031"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "-YY8UUdcaMKyZKdH",
    code: "LAHE",
    short: {
      en: "LAHANA",
      mm: "\u101C\u101F\u1014"
    },
    name: {
      en: "LAHE",
      mm: "\u101C\u1031\u101F\u1031"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "9g345tIdnxUmmufn",
    code: "LESHI",
    short: {
      en: "LAYANA",
      mm: "\u101C\u101B\u1014"
    },
    name: {
      en: "LE SHI",
      mm: "\u101C\u1031\u101B\u103E\u102E\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "u9odDjYskhnqGyPo",
    code: "NANYUN",
    short: {
      en: "NAYANA",
      mm: "\u1014\u101A\u1014"
    },
    name: {
      en: "NAN YUN",
      mm: "\u1014\u1014\u103A\u1038\u101A\u103D\u1014\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "x1nbdbSilCIiTGmR",
    code: "KALEWA",
    short: {
      en: "KALAWA",
      mm: "\u1000\u101C\u1040"
    },
    name: {
      en: "KALEWA",
      mm: "\u1000\u101C\u1031\u1038\u101D"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "26wLO7jJW10Qou3c",
    code: "MINKIN",
    short: {
      en: "MAKANA",
      mm: "\u1019\u1000\u1014"
    },
    name: {
      en: "MIN KIN",
      mm: "\u1019\u1004\u103A\u1038\u1000\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "klSwT1oH_su_6f28",
    code: "HTIGYAING",
    short: {
      en: "HTAKHANA",
      mm: "\u1011\u1001\u1014"
    },
    name: {
      en: "HTI GYAING",
      mm: "\u1011\u102E\u1038\u1001\u103B\u102D\u102F\u1004\u1037\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "kJOqgpHu_Ou-nsw1",
    code: "INDAW",
    short: {
      en: "AHTANA",
      mm: "\u1021\u1010\u1014"
    },
    name: {
      en: "IN DAW-SAGAING",
      mm: "\u1021\u1004\u103A\u1038\u1010\u1031\u102C\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "fNn81PTzG4BzIZHk",
    code: "KATHA",
    short: {
      en: "KATHANA",
      mm: "\u1000\u101E\u1014"
    },
    name: {
      en: "KA THA",
      mm: "\u1000\u101E\u102C"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "4uiPBMb4P45-KIKy",
    code: "WUNTHO",
    short: {
      en: "WATHANA",
      mm: "\u101D\u101E\u1014"
    },
    name: {
      en: "WUNTHO",
      mm: "\u101D\u1014\u103A\u1038\u101E\u102D\u102F"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "mzMZCuxyylpYpz2C",
    code: "PHAUNGPYIN",
    short: {
      en: "PHAPANA",
      mm: "\u1016\u1015\u1014"
    },
    name: {
      en: "PHAUNG PYIN",
      mm: "\u1016\u1031\u102C\u1004\u103A\u1038\u1015\u103C\u1004\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "BH37AcqtgC7Ug_ld",
    code: "CHAUNGOO",
    short: {
      en: "KHAOUTA",
      mm: "\u1001\u1025\u1010"
    },
    name: {
      en: "CHAUNG OO",
      mm: "\u1001\u103B\u1031\u102C\u1004\u103A\u1038\u1026\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "QgCH59oskLO2MoOY",
    code: "MONYWA",
    short: {
      en: "MAYANA",
      mm: "\u1019\u101B\u1014"
    },
    name: {
      en: "MON YWA",
      mm: "\u1019\u102F\u1036\u101B\u103D\u102C"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "1OrTVMg1p0cszLFL",
    code: "DEPAYIN",
    short: {
      en: "DAPAYA",
      mm: "\u1012\u1015\u101A"
    },
    name: {
      en: "DE PA YIN",
      mm: "\u1012\u102E\u1015\u1032\u101A\u1004\u103A\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "lhNIgqUOKb56afyE",
    code: "KAMBALU",
    short: {
      en: "KABALA",
      mm: "\u1000\u1018\u101C"
    },
    name: {
      en: "KAM BA LU",
      mm: "\u1000\u1014\u1037\u103A\u1018\u101C\u1030"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "FIwnV9Io6oxzj9ke",
    code: "KHINU",
    short: {
      en: "KHAOUNA",
      mm: "\u1001\u1025\u1014"
    },
    name: {
      en: "KHIN U",
      mm: "\u1001\u1004\u103A\u1026\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "JPfgft1uKXujn2Qr",
    code: "SHWEBO",
    short: {
      en: "YABANA",
      mm: "\u101B\u1018\u1014"
    },
    name: {
      en: "SHWE BO",
      mm: "\u101B\u103D\u103E\u1031\u1018\u102D\u102F"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "iaa9zF8aiwKKV_L_",
    code: "TANSEI",
    short: {
      en: "TASANA",
      mm: "\u1010\u1006\u1014"
    },
    name: {
      en: "TAN SEI",
      mm: "\u1010\u1014\u1037\u103A\u1006\u100A\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "hbv3gfxKHHIByrb1",
    code: "WETLET",
    short: {
      en: "WALANA",
      mm: "\u101D\u101C\u1014"
    },
    name: {
      en: "WET LET",
      mm: "\u101D\u1000\u103A\u101C\u1000\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "iBa2GG6GAfM1w4Tu",
    code: "BUTALIN",
    short: {
      en: "BATALA",
      mm: "\u1018\u1010\u101C"
    },
    name: {
      en: "BU TA LIN",
      mm: "\u1018\u102F\u1010\u101C\u1004\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "9ht_wfDAhF0JEaMr",
    code: "TAMU",
    short: {
      en: "TAMANA",
      mm: "\u1010\u1019\u1014"
    },
    name: {
      en: "TAMU",
      mm: "\u1010\u1019\u1030\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "D2kXH8zBQlWZoNL7",
    code: "KANI",
    short: {
      en: "KANANA",
      mm: "\u1000\u1014\u1014"
    },
    name: {
      en: "KANI",
      mm: "\u1000\u1014\u102E"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "qIsjbicMvI2_jLF3",
    code: "PALAE",
    short: {
      en: "PALANA",
      mm: "\u1015\u101C\u1014"
    },
    name: {
      en: "PALAE",
      mm: "\u1015\u102F\u101C\u1032"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "TIfpoGgsqV_IlB3r",
    code: "MOPINE LOOT",
    short: {
      en: "MAPALA",
      mm: "\u1019\u1015\u101C"
    },
    name: {
      en: "MOPINE LOOT",
      mm: "\u1019\u102D\u102F\u1015\u102D\u102F\u1004\u103A\u1038\u101C\u103D\u1010\u103A"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "gn5XjF2LJNsL3k4V",
    code: "MINMU",
    short: {
      en: "MAMATA",
      mm: "\u1019\u1019\u1010"
    },
    name: {
      en: "MINMU",
      mm: "\u1019\u103C\u1004\u103A\u1038\u1019\u1030"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "O4KgfLPTpN5w3WBe",
    code: "KHAN TEE(UPPER)",
    short: {
      en: "DAHANA",
      mm: "\u1012\u101F\u1014"
    },
    name: {
      en: "DON HEE",
      mm: "\u1012\u102F\u1036\u101F\u102E\u1038"
    },
    stateId: "EbUz7oziqo6OB5pL",
    stateCode: "5"
  },
  {
    id: "VUxj0QjS1YcjTo6-",
    code: "KYUNSU",
    short: {
      en: "KASANA",
      mm: "\u1000\u1005\u1014"
    },
    name: {
      en: "KYUN SU",
      mm: "\u1000\u103B\u103D\u1014\u103A\u1038\u1005\u102F"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "oQ8xGCkKsQ4OVIYB",
    code: "MYEIK",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MYEIK",
      mm: "\u1019\u103C\u102D\u1010\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "Ppv50cDzzlRxNmae",
    code: "MYEIKASHAE",
    short: {
      en: "MAAHYA",
      mm: "\u1019\u1021\u101B"
    },
    name: {
      en: "MYEIK A SHE",
      mm: "\u1019\u103C\u102D\u1010\u103A\u1021\u101B\u103E\u1031\u1037"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "4rCC9V4PSd4YsAJh",
    code: "TANINTHARYI",
    short: {
      en: "TANATHA",
      mm: "\u1010\u1014\u101E"
    },
    name: {
      en: "TA NIN THAR YI-THA",
      mm: "\u1010\u1014\u1004\u103A\u1039\u101E\u102C\u101B\u102E"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "cCye9cIXevApXJlQ",
    code: "PYIGYIMANDAING",
    short: {
      en: "PAKAMA",
      mm: "\u1015\u1000\u1019"
    },
    name: {
      en: "PYI GYI MAN DAING",
      mm: "\u1015\u103C\u100A\u103A\u1000\u103C\u102E\u1038\u1019\u100F\u1039\u100D\u102D\u102F\u1004\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "cS52I0lfMyvTWzMG",
    code: "PALAUK",
    short: {
      en: "PALATA",
      mm: "\u1015\u101C\u1010"
    },
    name: {
      en: "PA LAUK",
      mm: "\u1015\u101C\u1031\u102C\u1000\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "HIveIJYbrI1EbOUT",
    code: "YEBYU",
    short: {
      en: "YAPHANA",
      mm: "\u101B\u1016\u1014"
    },
    name: {
      en: "YE BYU",
      mm: "\u101B\u1031\u1016\u103C\u1030"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "Ryn-PPekVDXpAEDf",
    code: "KAWTHOUNG",
    short: {
      en: "KATHANA",
      mm: "\u1000\u101E\u1014"
    },
    name: {
      en: "KAW THOUNG",
      mm: "\u1000\u1031\u102C\u1037\u101E\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "fLdBC3RFRhjHX4QB",
    code: "TANINTHARYI-YA",
    short: {
      en: "TATHAYA",
      mm: "\u1010\u101E\u101B"
    },
    name: {
      en: "TA NIN THAR YI",
      mm: "\u1010\u1014\u1004\u103A\u1039\u101E\u102C\u101B\u102E"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "__xkpK1HophRS7cF",
    code: "NGAYOKEKAUNG-TANINTHARYI",
    short: {
      en: "NGAYAKA",
      mm: "\u1004\u101B\u1000"
    },
    name: {
      en: "NGA YOKE KAUNG - TA NIN THAR YI",
      mm: "\u1004\u101B\u102F\u1010\u103A\u1000\u1031\u102C\u1004\u103A\u1038 - \u1010\u1014\u1004\u103A\u1039\u101E\u102C\u101B\u102E"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "4lVk74GIFgGJik73",
    code: "MYEIKANOUT",
    short: {
      en: "MAAHNA",
      mm: "\u1019\u1021\u1014"
    },
    name: {
      en: "MYEIK A NOUT",
      mm: "\u1019\u103C\u102D\u1010\u103A\u1021\u1014\u1031\u102C\u1000\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "aawkfxJd8P2EXcpM",
    code: "KARATHURI",
    short: {
      en: "KAYAYA",
      mm: "\u1000\u101B\u101B"
    },
    name: {
      en: "KA RA THU RI",
      mm: "\u1000\u101B\u101E\u102F\u101B\u102D"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "Lxgvg1lRviXj2hts",
    code: "LOUNGLON",
    short: {
      en: "LALANA",
      mm: "\u101C\u101C\u1014"
    },
    name: {
      en: "LOUNG LON",
      mm: "\u101C\u1031\u102C\u1004\u103A\u1038\u101C\u102F\u1036"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "VE1dfr8VmbWC7bBD",
    code: "PALAW",
    short: {
      en: "PALANA",
      mm: "\u1015\u101C\u1014"
    },
    name: {
      en: "PALAW",
      mm: "\u1015\u102F\u101C\u1031\u102C"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "G82DW13qbQyudW-1",
    code: "KHAMAUKKYI",
    short: {
      en: "KHAMAKA",
      mm: "\u1001\u1019\u1000"
    },
    name: {
      en: "KHA MAUK KYI",
      mm: "\u1001\u1019\u1031\u102C\u1000\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "tp6aiGIW6qVI57Gx",
    code: "DAWEI",
    short: {
      en: "HTAWANA",
      mm: "\u1011\u101D\u1014"
    },
    name: {
      en: "DA WEI",
      mm: "\u1011\u102C\u1038\u101D\u101A\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "5shTcXaLOO7usWtn",
    code: "KALEINAUNG",
    short: {
      en: "KALAAH",
      mm: "\u1000\u101C\u1021"
    },
    name: {
      en: "KA LEIN AUNG",
      mm: "\u1000\u101C\u102D\u1014\u103A\u1021\u1031\u102C\u1004\u103A"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "CyEy8bq2KXD6WXsa",
    code: "MYITTA",
    short: {
      en: "MATANA",
      mm: "\u1019\u1010\u1014"
    },
    name: {
      en: "MYIT TA",
      mm: "\u1019\u1031\u1010\u102C"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "j6sVngCzR4IPqRB6",
    code: "THAYETCHAUNG",
    short: {
      en: "THAYAKHA",
      mm: "\u101E\u101B\u1001"
    },
    name: {
      en: "THA YET CHAUNG",
      mm: "\u101E\u101B\u1000\u103A\u1001\u103B\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "sSxbuoBNIUhYJbNk",
    code: "BOKEPYIN",
    short: {
      en: "BAPANA",
      mm: "\u1018\u1015\u1014"
    },
    name: {
      en: "BOKE PYIN",
      mm: "\u1018\u102F\u1010\u103A\u1015\u103C\u1004\u103A\u1038"
    },
    stateId: "X8rt_XwuTgAggCju",
    stateCode: "6"
  },
  {
    id: "UpGyPd6L25VEdPd3",
    code: "SHWEGYIN",
    short: {
      en: "YAKANA",
      mm: "\u101B\u1000\u1014"
    },
    name: {
      en: "SHWEG YIN",
      mm: "\u101B\u103D\u103E\u1031\u1000\u103B\u1004\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "ZT984n-G_XLezmO6",
    code: "KAWA",
    short: {
      en: "KAWANA",
      mm: "\u1000\u101D\u1014"
    },
    name: {
      en: "KA WA",
      mm: "\u1000\u101D"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "C_dmO3JjxIJVZdNj",
    code: "PAUNDE",
    short: {
      en: "PATATA",
      mm: "\u1015\u1010\u1010"
    },
    name: {
      en: "PAUN DE",
      mm: "\u1015\u1031\u102B\u1004\u103A\u1038\u1010\u100A\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "TlduR30XkXtXbhfo",
    code: "KYAUKKYI",
    short: {
      en: "KAKANA",
      mm: "\u1000\u1000\u1014"
    },
    name: {
      en: "KYAUK KYI",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "-VzMq7MK3J6reN4x",
    code: "MINHLA-THAYAWADY",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MIN HLA",
      mm: "\u1019\u1004\u103A\u1038\u101C\u103E"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "c7eSHFdzmh_ZIvf5",
    code: "DAIKU",
    short: {
      en: "DAOUNA",
      mm: "\u1012\u1025\u1014"
    },
    name: {
      en: "DAIK U",
      mm: "\u1012\u102D\u102F\u1000\u103A\u1026\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "QGuKr1seDZSSpu-U",
    code: "KYAUKTAGA",
    short: {
      en: "KATAKHA",
      mm: "\u1000\u1010\u1001"
    },
    name: {
      en: "KYAUK TA GA",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1010\u1036\u1001\u102B\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "rhBMvVSYNlHhHT8j",
    code: "TANATPIN",
    short: {
      en: "THANAPA",
      mm: "\u101E\u1014\u1015"
    },
    name: {
      en: "TANATPIN",
      mm: "\u101E\u1014\u1015\u103A\u1015\u1004\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "p1pZ6RWsTbPyQibO",
    code: "WAW",
    short: {
      en: "WAMANA",
      mm: "\u101D\u1019\u1014"
    },
    name: {
      en: "WAW",
      mm: "\u101D\u1031\u102B"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "iBIC-ue3p-hAAjDT",
    code: "PADAUNG",
    short: {
      en: "PATANA",
      mm: "\u1015\u1010\u1014"
    },
    name: {
      en: "PA DAUNG",
      mm: "\u1015\u1014\u103A\u1038\u1010\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "uHs8NPhl809Nlgr9",
    code: "SHWEDAUNG",
    short: {
      en: "YATANA",
      mm: "\u101B\u1010\u1014"
    },
    name: {
      en: "SHWE DAUNG",
      mm: "\u101B\u103D\u103E\u1031\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "-CbHiLiNdbyIoDWi",
    code: "GYOBINGAUK",
    short: {
      en: "KAPAKA",
      mm: "\u1000\u1015\u1000"
    },
    name: {
      en: "GYO BIN GAUK",
      mm: "\u1000\u103C\u102D\u102F\u1037\u1015\u1004\u103A\u1000\u1031\u102C\u1000\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "-27Lh6FIUe_iMun5",
    code: "MONYO",
    short: {
      en: "MANYANA",
      mm: "\u1019\u100A\u1014"
    },
    name: {
      en: "MONYO",
      mm: "\u1019\u102D\u102F\u1038\u100A\u102D\u102F"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "M3kMDS86cRDzLn1U",
    code: "ZIGON",
    short: {
      en: "ZAKANA",
      mm: "\u1007\u1000\u1014"
    },
    name: {
      en: "ZIGON",
      mm: "\u1007\u102E\u1038\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "PrLQtsR_v5CDj1Dr",
    code: "HTANTAPIN",
    short: {
      en: "HTATAPA",
      mm: "\u1011\u1010\u1015"
    },
    name: {
      en: "HTAN TA PIN",
      mm: "\u1011\u1014\u103A\u1038\u1010\u1015\u1004\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "821GRLWIQ9Aa6657",
    code: "PYU",
    short: {
      en: "PHAMANA",
      mm: "\u1016\u1019\u1014"
    },
    name: {
      en: "PYU",
      mm: "\u1016\u103C\u1030\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "_y6hCtHBCIuNaAcU",
    code: "TOUNGOO",
    short: {
      en: "TANGANA",
      mm: "\u1010\u1004\u1014"
    },
    name: {
      en: "TOUNGOO",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1004\u1030"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "d7g19L0K4Z7iDKr7",
    code: "YAEDASHE",
    short: {
      en: "YATAYA",
      mm: "\u101B\u1010\u101B"
    },
    name: {
      en: "YAE DA SHE",
      mm: "\u101B\u1031\u1010\u102C\u101B\u103E\u100A\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "YYL-AhnQfi-W-c5j",
    code: "LETPADAN",
    short: {
      en: "LAPATA",
      mm: "\u101C\u1015\u1010"
    },
    name: {
      en: "LET PA DAN",
      mm: "\u101C\u1000\u103A\u1015\u1036\u1010\u1014\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "ehJklS2qpFDjXA3w",
    code: "OKPO",
    short: {
      en: "AHPHANA",
      mm: "\u1021\u1016\u1014"
    },
    name: {
      en: "OKPO",
      mm: "\u1021\u102F\u1010\u103A\u1016\u102D\u102F"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "Ci_V0duRSfL9k0e2",
    code: "THEGON",
    short: {
      en: "THAKANA",
      mm: "\u101E\u1000\u1014"
    },
    name: {
      en: "THE GON",
      mm: "\u101E\u1032\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "O1gjsyITz72gvxcm",
    code: "PAUKKHAUNG",
    short: {
      en: "PAKHATA",
      mm: "\u1015\u1001\u1010"
    },
    name: {
      en: "PAUKKHAUNG",
      mm: "\u1015\u1031\u102B\u1000\u103A\u1001\u1031\u102B\u1004\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "SUCOHZqGZDJkUfOI",
    code: "OKPHAT",
    short: {
      en: "AHPHANA",
      mm: "\u1021\u1016\u1014"
    },
    name: {
      en: "OK PHAT",
      mm: "\u1021\u102F\u1010\u103A\u1016\u103B\u1000\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "sHvIn8plwy-U9nnB",
    code: "THONSAE",
    short: {
      en: "THASANA",
      mm: "\u101E\u1006\u1014"
    },
    name: {
      en: "THON SAE",
      mm: "\u101E\u102F\u1036\u1038\u1006\u101A\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "ZHSzwEabWO-B2dw_",
    code: "KAYTUMATI",
    short: {
      en: "KATATA",
      mm: "\u1000\u1010\u1010"
    },
    name: {
      en: "KAY TU MA TI",
      mm: "\u1000\u1031\u1010\u102F\u1019\u1010\u102E"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "7CaefjA3UboaXAT5",
    code: "KUAUKKONE",
    short: {
      en: "KAKANA",
      mm: "\u1000\u1000\u1014"
    },
    name: {
      en: "KUAUK KONE",
      mm: "\u200B\u1000\u103B\u1031\u102C\u1000\u103A\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "04QudjFQ5UBP4tGm",
    code: "BAGO",
    short: {
      en: "PAKHANA",
      mm: "\u1015\u1001\u1014"
    },
    name: {
      en: "BAGO",
      mm: "\u1015\u1032\u1001\u1030\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "onEU1_dRNHW4DyTq",
    code: "PYAY",
    short: {
      en: "PAMANA",
      mm: "\u1015\u1019\u1014"
    },
    name: {
      en: "PYAY",
      mm: "\u1015\u103C\u100A\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "OAVACVgdGLOkVHou",
    code: "THAYAWADY",
    short: {
      en: "THAWATA",
      mm: "\u101E\u101D\u1010"
    },
    name: {
      en: "THA YA WA DY",
      mm: "\u101E\u102C\u101A\u102C\u101D\u1010\u102E"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "PsHaEttTtrWpvdO5",
    code: "NYAUNGLEBIN",
    short: {
      en: "NYALAPA",
      mm: "\u100A\u101C\u1015"
    },
    name: {
      en: "NYAUNG LE BIN",
      mm: "\u100A\u1031\u102C\u1004\u103A\u101C\u1031\u1038\u1015\u1004\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "4_X2AfTojfceN7Kz",
    code: "OATWIN",
    short: {
      en: "AHTANA",
      mm: "\u1021\u1010\u1014"
    },
    name: {
      en: "OA TWIN",
      mm: "\u1021\u102F\u1010\u103A\u1010\u103D\u1004\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "NWb7HcLUSYMVB4xx",
    code: "NATTALIN",
    short: {
      en: "NATALA",
      mm: "\u1014\u1010\u101C"
    },
    name: {
      en: "NAT TA LIN",
      mm: "\u1014\u1010\u103A\u1010\u101C\u1004\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "i_7MrNemGTYJSCP8",
    code: "PYUNTANSAR",
    short: {
      en: "PATASA",
      mm: "\u1015\u1010\u1006"
    },
    name: {
      en: "PYUN TAN SAR",
      mm: "\u1015\u103C\u103D\u1014\u103A\u1010\u1014\u103A\u1006\u102C"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "RhlPpoepmQgdWjOe",
    code: "MADAUNK",
    short: {
      en: "MADANA",
      mm: "\u1019\u1012\u1014"
    },
    name: {
      en: "MA DAUNK",
      mm: "\u1019\u1012\u1031\u102B\u1000\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "IYmG827ZQpD1tb8K",
    code: "PAENWEKONE",
    short: {
      en: "PANAKA",
      mm: "\u1015\u1014\u1000"
    },
    name: {
      en: "PAE NWE KONE",
      mm: "\u1015\u1032\u1014\u103D\u101A\u103A\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "UK3d5u7Ty8FTgCHR",
    code: "PAUNGTALAE",
    short: {
      en: "PATALA",
      mm: "\u1015\u1010\u101C"
    },
    name: {
      en: "PAUNG TA LAE",
      mm: "\u1015\u1031\u102B\u1004\u103A\u1038\u1010\u101C\u100A\u103A"
    },
    stateId: "zBMPM_jGuwbus35I",
    stateCode: "7"
  },
  {
    id: "o0z5cVWPkfga0pyE",
    code: "MINBU",
    short: {
      en: "MABANA",
      mm: "\u1019\u1018\u1014"
    },
    name: {
      en: "MIN BU",
      mm: "\u1019\u1004\u103A\u1038\u1018\u1030\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "-nNgh5Szy3N2LskT",
    code: "NGAPHAE",
    short: {
      en: "NGAPHANA",
      mm: "\u1004\u1016\u1014"
    },
    name: {
      en: "NGA PHAE",
      mm: "\u1004\u1016\u1032"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "v0ZputQ6bhO_vhJd",
    code: "PWINTPHYU",
    short: {
      en: "PAPHANA",
      mm: "\u1015\u1016\u1014"
    },
    name: {
      en: "PWINT PHYU",
      mm: "\u1015\u103D\u1004\u1037\u103A\u1016\u103C\u1030"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "Qd-lgt1oEldKNE3f",
    code: "SAKU",
    short: {
      en: "SAKANA",
      mm: "\u1005\u1000\u1014"
    },
    name: {
      en: "SA KU",
      mm: "\u1005\u1000\u102F"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "Sn67HyZFmmxqFSDL",
    code: "SALIN",
    short: {
      en: "SALANA",
      mm: "\u1005\u101C\u1014"
    },
    name: {
      en: "SA LIN",
      mm: "\u1005\u101C\u1004\u103A\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "yUNhDY1bl1rX7fvG",
    code: "MYAING",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MYAING",
      mm: "\u1019\u103C\u102D\u102F\u1004\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "5M0UcVWxY26ER3nY",
    code: "PAUK",
    short: {
      en: "PAMANA",
      mm: "\u1015\u1019\u1014"
    },
    name: {
      en: "PAUK",
      mm: "\u1015\u1031\u102B\u1000\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "1PPglEpG0LyA9wOV",
    code: "YAYSAKYO",
    short: {
      en: "YASAKA",
      mm: "\u101B\u1005\u1000"
    },
    name: {
      en: "YAY SA KYO",
      mm: "\u101B\u1031\u1005\u1000\u103C\u102D\u102F"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "u3XHrGVuLkP932L1",
    code: "KAMMA",
    short: {
      en: "KAMANA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KAM MA",
      mm: "\u1000\u1036\u1019"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "HpbZ9_MMh6YUbCI_",
    code: "MINHLA-MAGWAY",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MIN HLA-MAGWAY",
      mm: "\u1019\u1004\u103A\u1038\u101C\u103E"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "qy7AtOaGjDKGprio",
    code: "THAYET",
    short: {
      en: "THAYANA",
      mm: "\u101E\u101B\u1014"
    },
    name: {
      en: "THA YET",
      mm: "\u101E\u101B\u1000\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "fUxJOjaAiiy0356D",
    code: "SINPAUNGWAE",
    short: {
      en: "SAPAWA",
      mm: "\u1006\u1015\u1040"
    },
    name: {
      en: "SIN PAUNG WAE",
      mm: "\u1006\u1004\u103A\u1015\u1031\u102B\u1004\u103A\u101D\u1032"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "_c7XH023HJPZvcJh",
    code: "HSAW",
    short: {
      en: "SAMANA",
      mm: "\u1006\u1019\u1014"
    },
    name: {
      en: "HSAW",
      mm: "\u1006\u1031\u102C"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "Eh1eTvWgbavFg45U",
    code: "MINTONE",
    short: {
      en: "MATANA",
      mm: "\u1019\u1010\u1014"
    },
    name: {
      en: "MIN TONE",
      mm: "\u1019\u1004\u103A\u1038\u1010\u102F\u1014\u103A\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "FNrPp_Z5o4gNZklS",
    code: "TAUNGDWINGYI",
    short: {
      en: "TATAKA",
      mm: "\u1010\u1010\u1000"
    },
    name: {
      en: "TAUNG DWIN GYI",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1010\u103D\u1004\u103A\u1038\u1000\u103C\u102E\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "DK9mE0XT7ZYgvTQM",
    code: "HTILIN",
    short: {
      en: "HTALANA",
      mm: "\u1011\u101C\u1014"
    },
    name: {
      en: "HTI LIN",
      mm: "\u1011\u102E\u1038\u101C\u1004\u103A\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "w86KZCx2ugIvayhp",
    code: "CHAUK",
    short: {
      en: "KHAMANA",
      mm: "\u1001\u1019\u1014"
    },
    name: {
      en: "CHAUK",
      mm: "\u1001\u103B\u1031\u102C\u1000\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "CVkO0hqyM-0pgWDn",
    code: "MYAYHTAE",
    short: {
      en: "MAHTANA",
      mm: "\u1019\u1011\u1014"
    },
    name: {
      en: "MYAY HTAE",
      mm: "\u1019\u103C\u1031\u1011\u1032"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "3NHkosvrHv8S-1ha",
    code: "AUNGLAN",
    short: {
      en: "AHLANA",
      mm: "\u1021\u101C\u1014"
    },
    name: {
      en: "AUNG LAN",
      mm: "\u1021\u1031\u102C\u1004\u103A\u101C\u1036"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "qeA9kgXZQYVd04SF",
    code: "MYOTHIT-MAGWAY",
    short: {
      en: "MATHANA",
      mm: "\u1019\u101E\u1014"
    },
    name: {
      en: "MYO THIT-MAGWAY",
      mm: "\u1019\u103C\u102D\u102F\u1037\u101E\u1005\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "u7FQzukIDn1kf2zl",
    code: "PAKOKKU",
    short: {
      en: "PAKHAKA",
      mm: "\u1015\u1001\u1000"
    },
    name: {
      en: "PA KOK KU",
      mm: "\u1015\u1001\u102F\u1000\u1039\u1000\u1030"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "Ti55O51SEo0BvjPc",
    code: "MAGWAY",
    short: {
      en: "MAKANA",
      mm: "\u1019\u1000\u1014"
    },
    name: {
      en: "MA GWAY",
      mm: "\u1019\u1000\u103D\u1031\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "tsFnZj8yaujKVydq",
    code: "SEIKPHYU",
    short: {
      en: "SAPHANA",
      mm: "\u1006\u1016\u1014"
    },
    name: {
      en: "SEIK PHYU",
      mm: "\u1006\u102D\u1015\u103A\u1016\u103C\u1030"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "FkVx4E-5dJ8FqTag",
    code: "SAYTOTTARA",
    short: {
      en: "SATAYA",
      mm: "\u1005\u1010\u101B"
    },
    name: {
      en: "SAY TOT TA RA",
      mm: "\u1005\u1031\u1010\u102F\u1010\u1039\u1010\u101B\u102C"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "CYhfYyTEGDaD7YA7",
    code: "YAYNANCHAUNG",
    short: {
      en: "YANAKHA",
      mm: "\u101B\u1014\u1001"
    },
    name: {
      en: "YAY NAN CHAUNG",
      mm: "\u101B\u1031\u1014\u1036\u1001\u103B\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "6X-2nBE2egyCnITm",
    code: "GANGAW",
    short: {
      en: "GAGANA",
      mm: "\u1002\u1002\u1014"
    },
    name: {
      en: "GAN GAW",
      mm: "\u1002\u1014\u1037\u103A\u1002\u1031\u102B"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "GqjXbKk_8a3dpAJr",
    code: "KYAUKHTU",
    short: {
      en: "KAHTANA",
      mm: "\u1000\u1011\u1014"
    },
    name: {
      en: "KYAUK HTU",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1011\u102F"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "baal5VnZ-P1vZRQ8",
    code: "YAW",
    short: {
      en: "YAMANA",
      mm: "\u101A\u1019\u1014"
    },
    name: {
      en: "YAW",
      mm: "\u101A\u1031\u102C"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "91IeSpgF5_2X6v2N",
    code: "NATMAUK",
    short: {
      en: "NAMANA",
      mm: "\u1014\u1019\u1014"
    },
    name: {
      en: "NAT MAUK",
      mm: "\u1014\u1010\u103A\u1019\u1031\u102C\u1000\u103A"
    },
    stateId: "u431U0SGuX9lkur-",
    stateCode: "8"
  },
  {
    id: "Yy-x1u7JXiC0mRLN",
    code: "KYAUKSE",
    short: {
      en: "KASANA",
      mm: "\u1000\u1006\u1014"
    },
    name: {
      en: "KYAUK SE",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1006\u100A\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "s24xhSz9-fi9r8i5",
    code: "MYITTHAR",
    short: {
      en: "MATHANA",
      mm: "\u1019\u101E\u1014"
    },
    name: {
      en: "MYIT THAR",
      mm: "\u1019\u103C\u1005\u103A\u101E\u102C\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "wdr4b2Cn4LEmA6pU",
    code: "AUNGMYETHARZAN",
    short: {
      en: "AHMAZA",
      mm: "\u1021\u1019\u1007"
    },
    name: {
      en: "AUNG MYE THAR ZAN",
      mm: "\u1021\u1031\u102C\u1004\u103A\u1019\u103C\u1031\u101E\u102C\u1007\u1036"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "dJZW945YDHGv3-eQ",
    code: "CHANMYATHARZI",
    short: {
      en: "KHAMASA",
      mm: "\u1001\u1019\u1005"
    },
    name: {
      en: "CHAN MYA THAR ZI",
      mm: "\u1001\u103B\u1019\u103A\u1038\u1019\u103C\u1031\u1037\u101E\u102C\u1005\u100A\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "9QdAyBnMDEqdW1zz",
    code: "MAHAAUNGMYE",
    short: {
      en: "MAHAMA",
      mm: "\u1019\u101F\u1019"
    },
    name: {
      en: "MA HA AUNG MYE",
      mm: "\u1019\u101F\u102C\u1021\u1031\u102C\u1004\u103A\u1019\u103C\u1031"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "DKdjQ8olqz-vpfiy",
    code: "ZABUTHIRI",
    short: {
      en: "ZABATHA",
      mm: "\u1007\u1017\u101E"
    },
    name: {
      en: "ZA BU THIRI",
      mm: "\u1007\u1019\u1039\u1017\u1030\u101E\u102E\u101B\u102D"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "ynThlvLeMFOR0N8I",
    code: "KYAUKPADAUNG",
    short: {
      en: "KAPATA",
      mm: "\u1000\u1015\u1010"
    },
    name: {
      en: "KYAUK PA DAUNG",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1015\u1014\u103A\u1038\u1010\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "_8EmrD5ns9rLwYPm",
    code: "PATHEINGYI",
    short: {
      en: "PATHAKA",
      mm: "\u1015\u101E\u1000"
    },
    name: {
      en: "PA THEIN GYI",
      mm: "\u1015\u102F\u101E\u102D\u1019\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "ZpnOLsYWQmCb-RHM",
    code: "TADAU",
    short: {
      en: "TATAOU",
      mm: "\u1010\u1010\u1025"
    },
    name: {
      en: "TADAU",
      mm: "\u1010\u1036\u1010\u102C\u1038\u1026\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "447CkZG492J8TwnW",
    code: "SINGAING",
    short: {
      en: "SAKATA",
      mm: "\u1005\u1000\u1010"
    },
    name: {
      en: "SIN GAING",
      mm: "\u1005\u1009\u1037\u103A\u1000\u102D\u102F\u1004\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "zCAl687RBvKXg9vF",
    code: "SINKU",
    short: {
      en: "SAKANA",
      mm: "\u1005\u1000\u1014"
    },
    name: {
      en: "SIN KU",
      mm: "\u1005\u1009\u1037\u103A\u1000\u1030\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "gN77WiQ859GFd4r0",
    code: "OTTARATHIRI",
    short: {
      en: "AUTATHA",
      mm: "\u1025\u1010\u101E"
    },
    name: {
      en: "OT TA RA THIRI",
      mm: "\u1025\u1010\u1039\u1010\u101B\u101E\u102E\u101B\u102D"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "xn3kFcvdyd3mh4Gq",
    code: "POBBATHIRI",
    short: {
      en: "PABATHA",
      mm: "\u1015\u1017\u101E"
    },
    name: {
      en: "POB BA THIRI",
      mm: "\u1015\u102F\u1017\u1039\u1017\u101E\u102E\u101B\u102D"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "I7D-R0RwijzMAyvQ",
    code: "KUME",
    short: {
      en: "KAMANA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KU ME",
      mm: "\u1000\u1030\u1019\u1032"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "WzRc32_yKbZ5S0F3",
    code: "MAYMYO",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MAY MYO",
      mm: "\u1019\u1031\u1019\u103C\u102D\u102F\u1037"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "rq4exxAlROXKaNgl",
    code: "MANNSHAEMYAUK",
    short: {
      en: "MAYAMA",
      mm: "\u1019\u101B\u1019"
    },
    name: {
      en: "MANN SHAE MYAUK",
      mm: "\u1019\u1014\u103A\u1038\u101B\u103E\u1031\u1037\u1019\u103C\u1031\u102C\u1000\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "VMEyAxuTkt1-qyEV",
    code: "AMARAPURA",
    short: {
      en: "AHMAYA",
      mm: "\u1021\u1019\u101B"
    },
    name: {
      en: "A MA RA PU RA",
      mm: "\u1021\u1019\u101B\u1015\u1030\u101B"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "VuCC5mC1Enm9NP3m",
    code: "NATOGYI",
    short: {
      en: "NAHTAKA",
      mm: "\u1014\u1011\u1000"
    },
    name: {
      en: "NA TO GYI",
      mm: "\u1014\u103D\u102C\u1038\u1011\u102D\u102F\u1038\u1000\u103C\u102E\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "BhYX-gtw-pd8GucA",
    code: "MANNNAUKMYAUK",
    short: {
      en: "MANAMA",
      mm: "\u1019\u1014\u1019"
    },
    name: {
      en: "MANN NAUK MYAUK",
      mm: "\u1019\u1014\u103A\u1038\u1014\u1031\u102C\u1000\u103A\u1019\u103C\u1031\u102C\u1000\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "dJucp8ldRbUocA0Q",
    code: "MANNNAUKTAUNG",
    short: {
      en: "MANATA",
      mm: "\u1019\u1014\u1010"
    },
    name: {
      en: "MANN NAUK TAUNG",
      mm: "\u1019\u1014\u103A\u1038\u1014\u1031\u102C\u1000\u103A\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "SNJTEZYEYYdSwdje",
    code: "MANNSHAEAUNG",
    short: {
      en: "MAYATA",
      mm: "\u1019\u101B\u1010"
    },
    name: {
      en: "MANN SHAE TAUNG",
      mm: "\u1019\u1014\u103A\u1038\u101B\u103E\u1031\u1037\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "ctjxT1TVs-1j13z9",
    code: "TATKON",
    short: {
      en: "TAKANA",
      mm: "\u1010\u1000\u1014"
    },
    name: {
      en: "TATKON",
      mm: "\u1010\u1015\u103A\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "wMEvpIt1m0slHoPa",
    code: "NYAUNGU",
    short: {
      en: "NYAOUNA",
      mm: "\u100A\u1025\u1014"
    },
    name: {
      en: "NYAUNG U",
      mm: "\u100A\u1031\u102C\u1004\u103A\u1026\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "VCeESLKeSCpbL2j9",
    code: "MEIKTILA",
    short: {
      en: "MAHTALA",
      mm: "\u1019\u1011\u101C"
    },
    name: {
      en: "MEI KTI LA",
      mm: "\u1019\u102D\u1010\u1039\u1011\u102E\u101C\u102C"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "2eZdnlvemYpeWH9j",
    code: "WUNDWIN",
    short: {
      en: "WATANA",
      mm: "\u101D\u1010\u1014"
    },
    name: {
      en: "WUN DWIN",
      mm: "\u101D\u1019\u103A\u1038\u1010\u103D\u1004\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "N-hNSUVP3h5LaI7r",
    code: "TAGAUNG",
    short: {
      en: "TAKATA",
      mm: "\u1010\u1000\u1010"
    },
    name: {
      en: "TA GAUNG",
      mm: "\u1010\u1000\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "w62qDkRBDwbiKMy8",
    code: "PYIGYITAKHUN",
    short: {
      en: "PAKAKHA",
      mm: "\u1015\u1000\u1001"
    },
    name: {
      en: "PYI GYI TA KHUN",
      mm: "\u1015\u103C\u100A\u103A\u1000\u103C\u102E\u1038\u1010\u1036\u1001\u103D\u1014\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "rsGsFgXbYHgi8-9h",
    code: "THAZI",
    short: {
      en: "THASANA",
      mm: "\u101E\u1005\u1014"
    },
    name: {
      en: "THA ZI",
      mm: "\u101E\u102C\u1005\u100A\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "xlYsO9DL2khUNFkS",
    code: "MYINGYAN",
    short: {
      en: "MAKHANA",
      mm: "\u1019\u1001\u1014"
    },
    name: {
      en: "MYIN GYAN",
      mm: "\u1019\u103C\u1004\u103A\u1038\u1001\u103C\u1036"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "I1b39XFHcpDNdncy",
    code: "NGAZUN",
    short: {
      en: "NGAZANA",
      mm: "\u1004\u1007\u1014"
    },
    name: {
      en: "NGAN ZUN",
      mm: "\u1004\u102B\u1014\u103A\u1038\u1007\u103D\u1014\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "hynvIcJ4p69iGeLO",
    code: "NGATHAYAUK",
    short: {
      en: "NGATHAYA",
      mm: "\u1004\u101E\u101B"
    },
    name: {
      en: "NGA THA YAUK",
      mm: "\u1004\u102B\u1038\u101E\u101B\u1031\u102C\u1000\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "7FdSE4aRiwcHPyLW",
    code: "MOGOK",
    short: {
      en: "MAKANA",
      mm: "\u1019\u1000\u1014"
    },
    name: {
      en: "MOGOK",
      mm: "\u1019\u102D\u102F\u1038\u1000\u102F\u1010\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "dWmV8TALPKlT7X1W",
    code: "PYINOOLWIN",
    short: {
      en: "PAOULA",
      mm: "\u1015\u1025\u101C"
    },
    name: {
      en: "PYIN OO LWIN",
      mm: "\u1015\u103C\u1004\u103A\u200C\u1026\u1038\u101C\u103D\u1004\u103A\u200C"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "HwGp-N5JK1eKCfF6",
    code: "THABEIKKYIN",
    short: {
      en: "THAPAKA",
      mm: "\u101E\u1015\u1000"
    },
    name: {
      en: "THA BEIK KYIN",
      mm: "\u101E\u1015\u102D\u1010\u103A\u1000\u103B\u1004\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "IhhrvLN4RGPE_oI7",
    code: "PYAWBWE",
    short: {
      en: "PABANA",
      mm: "\u1015\u1018\u1014"
    },
    name: {
      en: "PYAW BWE",
      mm: "\u1015\u103B\u1031\u102C\u103A\u1018\u103D\u101A\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "aV3n30bpYpfjftPe",
    code: "YAMETHIN",
    short: {
      en: "YAMATHA",
      mm: "\u101B\u1019\u101E"
    },
    name: {
      en: "YA ME THIN",
      mm: "\u101B\u1019\u100A\u103A\u1038\u101E\u1004\u103A\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "DQlUKc6ejvr4pYhu",
    code: "DEKKHINATHIRI",
    short: {
      en: "DAKHATHA",
      mm: "\u1012\u1001\u101E"
    },
    name: {
      en: "DEK KHI NA THIRI",
      mm: "\u1012\u1000\u1039\u1001\u102D\u100F\u101E\u102E\u101B\u102D"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "vdYRqAR_EDMdkFvy",
    code: "LEWE",
    short: {
      en: "LAWANA",
      mm: "\u101C\u101D\u1014"
    },
    name: {
      en: "LEWE",
      mm: "\u101C\u101A\u103A\u101D\u1031\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "jiUCUunNLErLnvyj",
    code: "PYINMANA",
    short: {
      en: "PAMANA",
      mm: "\u1015\u1019\u1014"
    },
    name: {
      en: "PYIN MA NA",
      mm: "\u1015\u103B\u1009\u103A\u1038\u1019\u1014\u102C\u1038"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "LqfEkS4_G1K-Kxnm",
    code: "ZEYARTHIRI",
    short: {
      en: "ZAYATHA",
      mm: "\u1007\u101A\u101E"
    },
    name: {
      en: "ZE YAR THIRI",
      mm: "\u1007\u1031\u101A\u103B\u102C\u101E\u102E\u101B\u102D"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "S-YlIvEXHe4FMHu_",
    code: "MADAYA",
    short: {
      en: "MATAYA",
      mm: "\u1019\u1010\u101B"
    },
    name: {
      en: "MA DA YA",
      mm: "\u1019\u1010\u1039\u1010\u101B\u102C"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "fdcDWBEXcCmIv96M",
    code: "TAUNGTHA",
    short: {
      en: "TATHANA",
      mm: "\u1010\u101E\u1014"
    },
    name: {
      en: "TAUNG THA",
      mm: "\u1010\u1031\u102C\u1004\u103A\u101E\u102C"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "5XPfw_dpPtzZ0fdL",
    code: "MAHLAING",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MA HLAING",
      mm: "\u1019\u101C\u103E\u102D\u102F\u1004\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "QLG4vgvPJVOnirhy",
    code: "CHANAYETHARZAN",
    short: {
      en: "KHAAHZA",
      mm: "\u1001\u1021\u1007"
    },
    name: {
      en: "CHAN AYE THAR ZAN",
      mm: "\u1001\u103B\u1019\u103A\u1038\u1021\u1031\u1038\u101E\u102C\u1007\u1036"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "UP2KQOz9vaE_20FG",
    code: "BAGAN",
    short: {
      en: "-",
      mm: "-"
    },
    name: {
      en: "BAGAN",
      mm: "\u1015\u102F\u1002\u1036"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "A2i3KO_tPsZdZJX4",
    code: "SHWEKYIN",
    short: {
      en: "YAKANA",
      mm: "\u101B\u1000\u1014"
    },
    name: {
      en: "SHWEKYIN",
      mm: "\u101B\u103D\u103E\u1031\u1000\u103B\u1004\u103A"
    },
    stateId: "5PflwjWItczLTOof",
    stateCode: "9"
  },
  {
    id: "3ZFbwzx4RgIWwqzz",
    code: "BILIN",
    short: {
      en: "BALANA",
      mm: "\u1018\u101C\u1014"
    },
    name: {
      en: "BI LIN",
      mm: "\u1018\u102E\u101C\u1004\u103A\u1038"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "dfN0sOQvvrCtv0l-",
    code: "PAUNG",
    short: {
      en: "PAMANA",
      mm: "\u1015\u1019\u1014"
    },
    name: {
      en: "PAUNG",
      mm: "\u1015\u1031\u102B\u1004\u103A"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "IteUPxE6EGnDqbbn",
    code: "YE",
    short: {
      en: "YAMANA",
      mm: "\u101B\u1019\u1014"
    },
    name: {
      en: "YE",
      mm: "\u101B\u1031\u1038"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "KpItim_6rbvbe0zU",
    code: "KYAIKKHAMI",
    short: {
      en: "KAKHAMA",
      mm: "\u1000\u1001\u1019"
    },
    name: {
      en: "KYAIK KHA MI",
      mm: "\u1000\u103B\u102D\u102F\u1000\u103A\u1001\u1019\u102E"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "ZymwfgXhM8w_XbHW",
    code: "LAMINE",
    short: {
      en: "LAMANA",
      mm: "\u101C\u1019\u1014"
    },
    name: {
      en: "LA MINE",
      mm: "\u101C\u1019\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "LnLFtCrD8ijGqvVG",
    code: "CHAUNGZON",
    short: {
      en: "KHASANA",
      mm: "\u1001\u1006\u1014"
    },
    name: {
      en: "CHAUNG ZON",
      mm: "\u1001\u103B\u1031\u102C\u1004\u103A\u1038\u1006\u102F\u1036"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "hxWvHrSQsRSUXq1S",
    code: "KYAIKEMARAW",
    short: {
      en: "KAMAYA",
      mm: "\u1000\u1019\u101B"
    },
    name: {
      en: "KYAIKE MA RAW",
      mm: "\u1000\u103B\u102D\u102F\u1000\u103A\u1019\u101B\u1031\u102C"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "RNlgtOGsd2L6G1LH",
    code: "MAWLAMYINE",
    short: {
      en: "MALAMA",
      mm: "\u1019\u101C\u1019"
    },
    name: {
      en: "MAW LA MYINE",
      mm: "\u1019\u1031\u102C\u103A\u101C\u1019\u103C\u102D\u102F\u1004\u103A"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "7rgFP6a0MuSiivau",
    code: "MUDON",
    short: {
      en: "MADANA",
      mm: "\u1019\u1012\u1014"
    },
    name: {
      en: "MUDON",
      mm: "\u1019\u102F\u1012\u102F\u1036"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "BRsNzV8svoNFVpdm",
    code: "THANBYUZAYAT",
    short: {
      en: "THAPHAYA",
      mm: "\u101E\u1016\u101B"
    },
    name: {
      en: "THAN BYU ZA YAT",
      mm: "\u101E\u1036\u1016\u103C\u1030\u1007\u101B\u1015\u103A"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "ICN-j5aDsNvHfpt7",
    code: "KYAIKTO",
    short: {
      en: "KAHTANA",
      mm: "\u1000\u1011\u1014"
    },
    name: {
      en: "KYAIK TO",
      mm: "\u1000\u103B\u102D\u102F\u1000\u103A\u1011\u102D\u102F"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "r1P1_FN5TOTfeYfX",
    code: "THAHTON",
    short: {
      en: "THAHTANA",
      mm: "\u101E\u1011\u1014"
    },
    name: {
      en: "THAHTON",
      mm: "\u101E\u1011\u102F\u1036"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "Oc3qZ6TAbDCGzm9X",
    code: "KHAWZAR",
    short: {
      en: "KHAZANA",
      mm: "\u1001\u1007\u1014"
    },
    name: {
      en: "KHAW ZAR",
      mm: "\u1001\u1031\u102B\u1007\u102C"
    },
    stateId: "uQgglJ-AhohYQJNB",
    stateCode: "10"
  },
  {
    id: "hXv7BUQLa1ORBS85",
    code: "GWA",
    short: {
      en: "GAMANA",
      mm: "\u1002\u1019\u1014"
    },
    name: {
      en: "GWA",
      mm: "\u1002\u103D"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "a5kASAP5stP2BOXC",
    code: "MYEBON",
    short: {
      en: "MAPATA",
      mm: "\u1019\u1015\u1010"
    },
    name: {
      en: "MYE BON",
      mm: "\u1019\u103C\u1031\u1015\u102F\u1036"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "CLmdR7dJaNiP4N0J",
    code: "TAUNGPYO",
    short: {
      en: "TAPAWA",
      mm: "\u1010\u1015\u1040"
    },
    name: {
      en: "TAUNG PYO",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1015\u103C\u102D\u102F\u101C\u1000\u103A\u101D\u1032\u1012"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "Vl5ebxQn_qxGzpI7",
    code: "THANDWE",
    short: {
      en: "THATANA",
      mm: "\u101E\u1010\u1014"
    },
    name: {
      en: "THAN DWE",
      mm: "\u101E\u1036\u1010\u103D\u1032"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "8WA5b_JGAQGWvLwI",
    code: "BUTHIDAUNG",
    short: {
      en: "BATHATA",
      mm: "\u1018\u101E\u1010"
    },
    name: {
      en: "BU THI DAUNG",
      mm: "\u1018\u1030\u1038\u101E\u102E\u1038\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "_gdnz83gPR0qaX-o",
    code: "MAUNG TAW",
    short: {
      en: "BATHATA",
      mm: "\u1018\u101E\u1010"
    },
    name: {
      en: "MAUNGTAW",
      mm: "\u1019\u1031\u102C\u1004\u103A\u1038\u1010\u1031\u102C"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "TEzcGfrBKh9W5LSZ",
    code: "PONNAGYUN-1",
    short: {
      en: "PANATA",
      mm: "\u1015\u100F\u1010"
    },
    name: {
      en: "PON NA GYUN",
      mm: "\u1015\u102F\u100F\u1039\u100F\u102C\u1038\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "iuBuiTI1hatSutwf",
    code: "SITTWAY",
    short: {
      en: "SATANA",
      mm: "\u1005\u1010\u1014"
    },
    name: {
      en: "SIT TWAY",
      mm: "\u1005\u1005\u103A\u1010\u103D\u1031"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "NJ_UUyhsZ69urvuk",
    code: "KYEINTALI",
    short: {
      en: "KATALA",
      mm: "\u1000\u1010\u101C"
    },
    name: {
      en: "KYEI NTA LI",
      mm: "\u1000\u103B\u102D\u1014\u1039\u1010\u101C\u102E"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "DZ5iTDGEf_wPK_yO",
    code: "AN",
    short: {
      en: "AHMANA",
      mm: "\u1021\u1019\u1014"
    },
    name: {
      en: "AN",
      mm: "\u1021\u1019\u103A\u1038"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "NkEsafi60YXgB1R8",
    code: "KYAUKPYU",
    short: {
      en: "KAPHANA",
      mm: "\u1000\u1016\u1014"
    },
    name: {
      en: "KYAUK PYU",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1016\u103C\u1030"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "B0xizr4QR0mRAsW8",
    code: "MANNAUNG",
    short: {
      en: "MAAHNA",
      mm: "\u1019\u1021\u1014"
    },
    name: {
      en: "MANN AUNG",
      mm: "\u1019\u102C\u1014\u103A\u1021\u1031\u102C\u1004\u103A"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "mUE3fc36BsLh3vIf",
    code: "YANBYE",
    short: {
      en: "YABANA",
      mm: "\u101B\u1017\u1014"
    },
    name: {
      en: "YAN BYE",
      mm: "\u101B\u1019\u103A\u1038\u1017\u103C\u1032"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "sFmS8GnBmMYJsLHR",
    code: "MAUNGTAW",
    short: {
      en: "MATANA",
      mm: "\u1019\u1010\u1014"
    },
    name: {
      en: "MAUNG TAW",
      mm: "\u1019\u1031\u102C\u1004\u103A\u1038\u1010\u1031\u102C"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "Fv6N-Md2_3a6_EMr",
    code: "MINBYA",
    short: {
      en: "MAPANA",
      mm: "\u1019\u1015\u1014"
    },
    name: {
      en: "MIN BYA",
      mm: "\u1019\u1004\u103A\u1038\u1015\u103C\u102C\u1038"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "bhbhsMrZf1Hlxbi4",
    code: "MYAUKU",
    short: {
      en: "MAOUNA",
      mm: "\u1019\u1025\u1014"
    },
    name: {
      en: "MYAUK U",
      mm: "\u1019\u103C\u1031\u102C\u1000\u103A\u1026\u1038"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "MXNQnSonoZpxcQmJ",
    code: "PAUKTAW",
    short: {
      en: "PATANA",
      mm: "\u1015\u1010\u1014"
    },
    name: {
      en: "PAUK TAW",
      mm: "\u1015\u1031\u102B\u1000\u103A\u1010\u1031\u102C"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "KD_Y4qXlsHogtPK8",
    code: "PONNAGYUN",
    short: {
      en: "PANAKA",
      mm: "\u1015\u100F\u1000"
    },
    name: {
      en: "PON NA GYUN",
      mm: "\u1015\u102F\u100F\u1039\u100F\u102C\u1038\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "jOUXDbW0H4OhAQMU",
    code: "YATHEDAUNG",
    short: {
      en: "YATHATA",
      mm: "\u101B\u101E\u1010"
    },
    name: {
      en: "YA THE DAUNG",
      mm: "\u101B\u101E\u1031\u1037\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "jX1hM22WVl_-_IHj",
    code: "KYAUKTAW",
    short: {
      en: "KATANA",
      mm: "\u1000\u1010\u1014"
    },
    name: {
      en: "KYAUK TAW",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1010\u1031\u102C\u103A"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "ibFQDVT8iPws8DVW",
    code: "TOUNGUP",
    short: {
      en: "TAKANA",
      mm: "\u1010\u1000\u1014"
    },
    name: {
      en: "TOUNGUP",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1000\u102F\u1010\u103A"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "M3ufwykApSG0IO8n",
    code: "MAEI",
    short: {
      en: "MAAHTA",
      mm: "\u1019\u1021\u1010"
    },
    name: {
      en: "MAEI",
      mm: "\u1019\u1021\u102E"
    },
    stateId: "OfeDuBL9FsUHKi8j",
    stateCode: "11"
  },
  {
    id: "iDAG41mvlUp7D0Qy",
    code: "DAGONMYOTHIT(EAST)",
    short: {
      en: "DAGAYA",
      mm: "\u1012\u1002\u101B"
    },
    name: {
      en: "DAGON MYOTHIT(EAST)",
      mm: "\u1012\u1002\u102F\u1036\u1019\u103C\u102D\u102F\u1037\u101E\u1005\u103A (\u1021\u101B\u103E\u1031\u1037)"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "_4sJlYCailnh394X",
    code: "DAWBON",
    short: {
      en: "DAPANA",
      mm: "\u1012\u1015\u1014"
    },
    name: {
      en: "DAW BON",
      mm: "\u1012\u1031\u102B\u1015\u102F\u1036"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "_Agvhuwan67YtEIt",
    code: "SOUTHOKKALAPA",
    short: {
      en: "OUKATA",
      mm: "\u1025\u1000\u1010"
    },
    name: {
      en: "SOUTH OKKALAPA",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1025\u1000\u1039\u1000\u101C\u102C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "KAMe9hxWURfLzOu2",
    code: "THAKAYTA",
    short: {
      en: "THAKATA",
      mm: "\u101E\u1000\u1010"
    },
    name: {
      en: "THA KAY TA",
      mm: "\u101E\u102C\u1000\u1031\u1010"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "-v8PkAOXg8VmBrGE",
    code: "THINGANGYUN",
    short: {
      en: "THAGAKA",
      mm: "\u101E\u1003\u1000"
    },
    name: {
      en: "THIN GAN GYUN",
      mm: "\u101E\u1004\u103A\u1039\u1003\u1014\u103A\u1038\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "9-gh-5mvajAICDVj",
    code: "YANKIN",
    short: {
      en: "YAKANA",
      mm: "\u101B\u1000\u1014"
    },
    name: {
      en: "YAN KIN",
      mm: "\u101B\u1014\u103A\u1000\u1004\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "KxYyjXCcKG9YPMXS",
    code: "HMAWBY",
    short: {
      en: "MABANA",
      mm: "\u1019\u1018\u1014"
    },
    name: {
      en: "HMAWBY",
      mm: "\u1019\u103E\u1031\u102C\u103A\u1018\u102E"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "IgnX35_WOSUU5VDK",
    code: "MINGALADON",
    short: {
      en: "MAGADA",
      mm: "\u1019\u1002\u1012"
    },
    name: {
      en: "MIN GA LA DON",
      mm: "\u1019\u1004\u103A\u1039\u1002\u101C\u102C\u1012\u102F\u1036"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "pwd98xktrwoB9r_p",
    code: "SHWEPYITHA",
    short: {
      en: "YAPATHA",
      mm: "\u101B\u1015\u101E"
    },
    name: {
      en: "SHWE PYI THA",
      mm: "\u101B\u103D\u103E\u1031\u1015\u103C\u100A\u103A\u101E\u102C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "wNDgPSwNpyuw976f",
    code: "TAIKKYI",
    short: {
      en: "TAKANA",
      mm: "\u1010\u1000\u1014"
    },
    name: {
      en: "TAIKKYI",
      mm: "\u1010\u102D\u102F\u1000\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "W-AROOoTuOy-t1s3",
    code: "DALA",
    short: {
      en: "DALANA",
      mm: "\u1012\u101C\u1014"
    },
    name: {
      en: "DALA",
      mm: "\u1012\u101C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "Rx0yPNNtvqGUrbiu",
    code: "KUNGYANGON",
    short: {
      en: "KAKHAKA",
      mm: "\u1000\u1001\u1000"
    },
    name: {
      en: "KUN GYAN GON",
      mm: "\u1000\u103D\u1019\u103A\u1038\u1001\u103C\u1036\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "wFAAKH5JvFbJvff2",
    code: "THANLYIN",
    short: {
      en: "THALANA",
      mm: "\u101E\u101C\u1014"
    },
    name: {
      en: "THAN LYIN",
      mm: "\u101E\u1014\u103A\u101C\u103B\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "XG00tDKHHiYtaBk6",
    code: "THONGWA",
    short: {
      en: "THAKHANA",
      mm: "\u101E\u1001\u1014"
    },
    name: {
      en: "THON GWA",
      mm: "\u101E\u102F\u1036\u1038\u1001\u103D"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "pMXkEkxPi_-0OxUO",
    code: "TWANTAY",
    short: {
      en: "TATANA",
      mm: "\u1010\u1010\u1014"
    },
    name: {
      en: "TWAN TAY",
      mm: "\u1010\u103D\u1036\u1010\u1031\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "c-Oxfy5rbPXNudl_",
    code: "BAHAN",
    short: {
      en: "BAHANA",
      mm: "\u1017\u101F\u1014"
    },
    name: {
      en: "BAHAN",
      mm: "\u1017\u101F\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "8Y7cH7ZIMdDScbKl",
    code: "HLAING",
    short: {
      en: "LAMANA",
      mm: "\u101C\u1019\u1014"
    },
    name: {
      en: "HLAING",
      mm: "\u101C\u103E\u102D\u102F\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "OjJkyZqewximexrE",
    code: "KYAUKTADA",
    short: {
      en: "KATATA",
      mm: "\u1000\u1010\u1010"
    },
    name: {
      en: "KYAUK TA DA",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1010\u1036\u1010\u102C\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "7xuMGxFX_CCYK-J1",
    code: "KYIMYINDINE",
    short: {
      en: "KAMATA",
      mm: "\u1000\u1019\u1010"
    },
    name: {
      en: "KYI MYIN DINE",
      mm: "\u1000\u103C\u100A\u1037\u103A\u1019\u103C\u1004\u103A\u1010\u102D\u102F\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "YIiRkpSlTrPj2FT0",
    code: "LATHA",
    short: {
      en: "LATHANA",
      mm: "\u101C\u101E\u1014"
    },
    name: {
      en: "LATHA",
      mm: "\u101C\u101E\u102C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "gWYtrRsyMtQEzgJK",
    code: "MAYANGON",
    short: {
      en: "MAYAKA",
      mm: "\u1019\u101B\u1000"
    },
    name: {
      en: "MAYAN GON",
      mm: "\u1019\u101B\u1019\u103A\u1038\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "cVe5VrIN8yHOZW_7",
    code: "HTANTABIN",
    short: {
      en: "HTATAPA",
      mm: "\u1011\u1010\u1015"
    },
    name: {
      en: "HTAN TA BIN",
      mm: "\u1011\u1014\u103A\u1038\u1010\u1015\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "64RVmkzB8opdqNWG",
    code: "TAMWAY",
    short: {
      en: "TAMANA",
      mm: "\u1010\u1019\u1014"
    },
    name: {
      en: "TA MWAY",
      mm: "\u1010\u102C\u1019\u103D\u1031"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "Uk2JoaMQq2mQSzxL",
    code: "HLINETHAYA",
    short: {
      en: "LATHAYA",
      mm: "\u101C\u101E\u101A"
    },
    name: {
      en: "HLINE THA YA",
      mm: "\u101C\u103E\u102D\u102F\u1004\u103A\u101E\u102C\u101A\u102C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "kRhoTjBgXZg1Yiz1",
    code: "SANGYOUNG",
    short: {
      en: "SAKHANA",
      mm: "\u1005\u1001\u1014"
    },
    name: {
      en: "SAN GYOUNG",
      mm: "\u1005\u1019\u103A\u1038\u1001\u103B\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "0EL9r8HLdKldiYAK",
    code: "BOTAHTAUNG",
    short: {
      en: "BATAHTA",
      mm: "\u1017\u1010\u1011"
    },
    name: {
      en: "BO TA HTAUNG",
      mm: "\u1017\u102D\u102F\u101C\u103A\u1010\u1011\u1031\u102C\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "x6CTcduRa3RIQ-UG",
    code: "SEIKKYI/KHANAUNGTO",
    short: {
      en: "SAKAKHA",
      mm: "\u1006\u1000\u1001"
    },
    name: {
      en: "SEIKKYI/KHANAUNGTO",
      mm: "\u1006\u102D\u1015\u103A\u1000\u103C\u102E\u1038\u1001\u1014\u1031\u102C\u1004\u103A\u1010\u102D\u102F"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "V1hY619qSyGNpqVw",
    code: "KAMAYUT",
    short: {
      en: "KAMAYA",
      mm: "\u1000\u1019\u101B"
    },
    name: {
      en: "KA MA YUT",
      mm: "\u1000\u1019\u102C\u101B\u103D\u1010\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "hTRvooxvhMF95MIX",
    code: "COCOGYUN",
    short: {
      en: "KAKAKA",
      mm: "\u1000\u1000\u1000"
    },
    name: {
      en: "CO CO GYUN",
      mm: "\u1000\u102D\u102F\u1000\u102D\u102F\u1038\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "DYk8ijZlc2dtbGeZ",
    code: "DAGON",
    short: {
      en: "DAGANA",
      mm: "\u1012\u1002\u1014"
    },
    name: {
      en: "DAGON",
      mm: "\u1012\u1002\u102F\u1036"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "oKLw6WHQSvfdQVgj",
    code: "MINGALATAUNGNYUNT",
    short: {
      en: "MAGATA",
      mm: "\u1019\u1002\u1010"
    },
    name: {
      en: "MINGALA TAUNG NYUNT",
      mm: "\u1019\u1004\u103A\u1039\u1002\u101C\u102C\u200C\u1010\u1031\u102C\u1004\u103A\u100A\u103D\u1014\u1037\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "oAIpEryyl6pOobUS",
    code: "NORTHOKKALAPA",
    short: {
      en: "OUKAMA",
      mm: "\u1025\u1000\u1019"
    },
    name: {
      en: "NORTH OKKALAPA",
      mm: "\u1019\u103C\u1031\u102C\u1000\u103A\u1025\u1000\u1039\u1000\u101C\u102C"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "dKFgvJZN0z3Qffve",
    code: "KHAYAN",
    short: {
      en: "KHAYANA",
      mm: "\u1001\u101B\u1014"
    },
    name: {
      en: "KHAYAN",
      mm: "\u1001\u101B\u1019\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "PKvlyTQgNvm1kZ2e",
    code: "SOUTHDAGON",
    short: {
      en: "DAGATA",
      mm: "\u1012\u1002\u1010"
    },
    name: {
      en: "SOUTH DAGON",
      mm: "\u1012\u1002\u102F\u1036\u1019\u103C\u102D\u102F\u1037\u101E\u1005\u103A (\u1010\u1031\u102C\u1004\u103A)"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "ZUAjaf3uH78FqtCJ",
    code: "NORTHDAGON",
    short: {
      en: "DAGAMA",
      mm: "\u1012\u1002\u1019"
    },
    name: {
      en: "NORTH DAGON",
      mm: "\u1012\u1002\u102F\u1036\u1019\u103C\u102D\u102F\u1037\u101E\u1005\u103A (\u1019\u103C\u1031\u102C\u1000\u103A)"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "nniwTR3vq2uB9de5",
    code: "LANMADAW",
    short: {
      en: "LAMATA",
      mm: "\u101C\u1019\u1010"
    },
    name: {
      en: "LAN MA DAW",
      mm: "\u101C\u1019\u103A\u1038\u1019\u1010\u1031\u102C\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "ozGRPYKD2UYfSduC",
    code: "DAGONMYOTHIT(SEIKKAN)",
    short: {
      en: "DAGASA",
      mm: "\u1012\u1002\u1006"
    },
    name: {
      en: "DAGON MYOTHIT(SEIKKAN)",
      mm: "\u1012\u1002\u102F\u1036\u1006\u102D\u1015\u103A\u1000\u1019\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "YuxsuAcI3DHipJaf",
    code: "HLEGU",
    short: {
      en: "LAKANA",
      mm: "\u101C\u1000\u1014"
    },
    name: {
      en: "HLEGU",
      mm: "\u101C\u103E\u100A\u103A\u1038\u1000\u1030\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "KZFQuHHRo7fanPlq",
    code: "SHWEPAUKKAN",
    short: {
      en: "OUKAMA",
      mm: "\u1025\u1000\u1019"
    },
    name: {
      en: "SHWE PAUK KAN",
      mm: "\u101B\u103D\u103E\u1031\u1015\u1031\u102B\u1000\u103A\u1000\u1036"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "7sTroQM7vfZnm0F9",
    code: "SEIKKAN",
    short: {
      en: "SAKANA",
      mm: "\u1006\u1000\u1014"
    },
    name: {
      en: "SEIKKAN",
      mm: "\u1006\u102D\u1015\u103A\u1000\u1019\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "oeaNIvKbSL7pEy_O",
    code: "PABEDAN",
    short: {
      en: "PABATA",
      mm: "\u1015\u1018\u1010"
    },
    name: {
      en: "PA BE DAN",
      mm: "\u1015\u1014\u103A\u1038\u1018\u1032\u1010\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "rAJ6wXly9AWfqysi",
    code: "PAZUNTAUNG",
    short: {
      en: "PAZATA",
      mm: "\u1015\u1007\u1010"
    },
    name: {
      en: "PA ZUN TAUNG",
      mm: "\u1015\u102F\u1007\u103D\u1014\u103A\u1010\u1031\u102C\u1004\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "tBH7Joa7ckmBNwpd",
    code: "INSEIN",
    short: {
      en: "AHSANA",
      mm: "\u1021\u1005\u1014"
    },
    name: {
      en: "INSEIN",
      mm: "\u1021\u1004\u103A\u1038\u1005\u102D\u1014\u103A"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "p9d5igJorVIy2w8M",
    code: "AHLON",
    short: {
      en: "AHLANA",
      mm: "\u1021\u101C\u1014"
    },
    name: {
      en: "AHLON",
      mm: "\u1021\u101C\u102F\u1036"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "YxyWBsDrCAzgbSAZ",
    code: "KAWHMU",
    short: {
      en: "KAMANA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KAW HMU",
      mm: "\u1000\u1031\u102C\u1037\u1019\u103E\u1030\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "9zwTEJmARZAq32fK",
    code: "KYAUKTAN",
    short: {
      en: "KATANA",
      mm: "\u1000\u1010\u1014"
    },
    name: {
      en: "KYAUK TAN",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1010\u1014\u103A\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "8n9pK6cxtHoVd3_B",
    code: "TATAR",
    short: {
      en: "TATAHTA",
      mm: "\u1010\u1010\u1011"
    },
    name: {
      en: "TATAR",
      mm: "\u1010\u1036\u1010\u102C\u1038"
    },
    stateId: "Zvxm3m8cAwCeDgz1",
    stateCode: "12"
  },
  {
    id: "cGKynSQJAgrRJ6Wn",
    code: "PANGLONG",
    short: {
      en: "PALANA",
      mm: "\u1015\u101C\u1014"
    },
    name: {
      en: "PANG LONG",
      mm: "\u1015\u1004\u103A\u101C\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "6uqpDBxXoMx9EvK0",
    code: "MANTON",
    short: {
      en: "MATATA",
      mm: "\u1019\u1010\u1010"
    },
    name: {
      en: "MAN TON",
      mm: "\u1019\u1014\u103A\u1010\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "HeAxc7XUS8RkGgfu",
    code: "MINEYE",
    short: {
      en: "MAYANA",
      mm: "\u1019\u101B\u1014"
    },
    name: {
      en: "MINE YE",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101B\u101A\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "CiNgv2LY4cV1PIca",
    code: "NAPHANG",
    short: {
      en: "NAPHANA",
      mm: "\u1014\u1016\u1014"
    },
    name: {
      en: "NA PHANG",
      mm: "\u1014\u102C\u1038\u1016\u1014\u1037\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "QsZfm51DL_syLEhb",
    code: "MINEYAN",
    short: {
      en: "MAYANA",
      mm: "\u1019\u101A\u1014"
    },
    name: {
      en: "MINE YAN",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101A\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "u3caa414o1ouInJM",
    code: "PHEKON",
    short: {
      en: "PHAKHANA",
      mm: "\u1016\u1001\u1014"
    },
    name: {
      en: "PHE KON",
      mm: "\u1016\u101A\u103A\u1001\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "yK9qb86bmqL1dR86",
    code: "KARLI",
    short: {
      en: "KALADA",
      mm: "\u1000\u101C\u1012"
    },
    name: {
      en: "KARLI",
      mm: "\u1000\u102C\u101C\u102E"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "SR1cgGZhRfE2GxSv",
    code: "KYAUKTALONGYI",
    short: {
      en: "KATALA",
      mm: "\u1000\u1010\u101C"
    },
    name: {
      en: "KYAUK TA LON GYI",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1010\u101C\u102F\u1036\u1038\u1000\u103C\u102E\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "-3irfvmlk3QdiNhJ",
    code: "MINESAN-MONSAN",
    short: {
      en: "MASATA",
      mm: "\u1019\u1005\u1010"
    },
    name: {
      en: "MINESAN-MONSAN",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1005\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "RwmbIFLuvSjor95X",
    code: "MINEPHYAT",
    short: {
      en: "MAPHANA",
      mm: "\u1019\u1016\u1014"
    },
    name: {
      en: "MINE PHYAT",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1016\u103C\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "QmrGUfcnaRW06U5b",
    code: "TALAY",
    short: {
      en: "TALANA",
      mm: "\u1010\u101C\u1014"
    },
    name: {
      en: "TA LAY",
      mm: "\u1010\u102C\u101C\u1031"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "lfwo4BHmTvU4am25",
    code: "MAUKME",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MAUK ME",
      mm: "\u1019\u1031\u102C\u1000\u103A\u1019\u101A\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "iNeqXK1Ae-IcMr5Z",
    code: "CHINSHWEHAW",
    short: {
      en: "KHAYAHA",
      mm: "\u1001\u101B\u101F"
    },
    name: {
      en: "CHIN SHWE HAW",
      mm: "\u1001\u103B\u1004\u103A\u1038\u101B\u103D\u103E\u1031\u101F\u1031\u102C\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "ccwXdiDxMIYURMFO",
    code: "PANYAN",
    short: {
      en: "PAYANA",
      mm: "\u1010\u1001\u101C"
    },
    name: {
      en: "PANYAN",
      mm: "\u1010\u102C\u1001\u103B\u102E\u101C\u102D\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "_hqk2Z1PsQM3GQN_",
    code: "NYAUNGTAYAR",
    short: {
      en: "-",
      mm: "-"
    },
    name: {
      en: "NYAUNG TA YAR",
      mm: "\u100A\u1031\u102C\u1004\u103A\u1010\u101B\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "pwLLM4xGBExqRAWU",
    code: "MAWHTIKE",
    short: {
      en: "MAHTATA",
      mm: "\u1019\u1011\u1010"
    },
    name: {
      en: "MAW HTIKE",
      mm: "\u1019\u1031\u102C\u103A\u1011\u102D\u102F\u1000\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "jyLhxqYbb4Y-wpQF",
    code: "MINE KOKE",
    short: {
      en: "MAKHATA",
      mm: "\u1019\u1001\u1010"
    },
    name: {
      en: "MINE KOKE",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1001\u102F\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "RQcTT-3ZuXn5KgvM",
    code: "AUNGPAN",
    short: {
      en: "AHPANA",
      mm: "\u1021\u1015\u1014"
    },
    name: {
      en: "AUNG PAN",
      mm: "\u1021\u1031\u102C\u1004\u103A\u1015\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "XkxZbqLH9IZrVC5s",
    code: "AYETHARYAR",
    short: {
      en: "AHTHAYA",
      mm: "\u1021\u101E\u101A"
    },
    name: {
      en: "AYE THAR YAR",
      mm: "\u1021\u1031\u1038\u101E\u102C\u101A\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "NGK8eW-N-W8yZgK0",
    code: "HEHO",
    short: {
      en: "HAHANA",
      mm: "\u101F\u101F\u1014"
    },
    name: {
      en: "HEHO",
      mm: "\u101F\u1032\u101F\u102D\u102F\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "bNgbwzIbRiLNQuJg",
    code: "KALAW",
    short: {
      en: "KALANA",
      mm: "\u1000\u101C\u1014"
    },
    name: {
      en: "KA LAW",
      mm: "\u1000\u200C\u101C\u1031\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "FbIvm68X3U3mB2hb",
    code: "MINEPAUK",
    short: {
      en: "MAPAHTA",
      mm: "\u1019\u1015\u1011"
    },
    name: {
      en: "MINE PAUK",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1015\u1031\u102B\u1000\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "97Z783GG4y2GmuUf",
    code: "KENGTAUNG",
    short: {
      en: "KATATA",
      mm: "\u1000\u1010\u1010"
    },
    name: {
      en: "KENG TAUNG",
      mm: "\u1000\u103B\u102D\u102F\u1004\u103A\u1038\u1010\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "oMS2Q6J4_wa56jPm",
    code: "YATSAUK",
    short: {
      en: "YASANA",
      mm: "\u101B\u1005\u1014"
    },
    name: {
      en: "YAT SAUK",
      mm: "\u101B\u1000\u103A\u1005\u1031\u102C\u1000\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "twRnXz36Lcd2I6ux",
    code: "MINESAT",
    short: {
      en: "MASANA",
      mm: "\u1019\u1006\u1014"
    },
    name: {
      en: "MINE SAT",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1006\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "uSSRQosMmJvIyWPX",
    code: "MINETONE",
    short: {
      en: "MATANA",
      mm: "\u1019\u1010\u1014"
    },
    name: {
      en: "MINE TONE",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1010\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "9HzCkgfxR5QYbZRI",
    code: "MYINMU",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MYIN MU",
      mm: "\u1019\u103C\u1004\u103A\u1038\u1019\u1030"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Ethe3bgatSl0-Rnq",
    code: "MINE YAL",
    short: {
      en: "MARATA",
      mm: "\u1019\u101B\u1010"
    },
    name: {
      en: "MINE YAL",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101B\u101A\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "aPqbSUOOlAklv7io",
    code: "MONEKHA",
    short: {
      en: "-",
      mm: "-"
    },
    name: {
      en: "MONE KHA",
      mm: "\u1019\u102F\u1014\u103A\u1038\u1001"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Py1oGQov2TsfCGZ6",
    code: "SHWENYAUNG",
    short: {
      en: "YANYANA",
      mm: "\u101B\u100A\u1014"
    },
    name: {
      en: "SHWE NYAUNG",
      mm: "\u101B\u103D\u103E\u1031\u100A\u1031\u102C\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "nZLSh5y4NkngUgxb",
    code: "NANTIT",
    short: {
      en: "-",
      mm: "-"
    },
    name: {
      en: "NAN TIT",
      mm: "\u1014\u1014\u103A\u1010\u1005\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "PRG6AMRZ_16upoPY",
    code: "KHOLAN",
    short: {
      en: "KHALANA",
      mm: "\u1001\u101C\u1014"
    },
    name: {
      en: "KHO LAN",
      mm: "\u1001\u102D\u102F\u101C\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "jjfOa6t--G_6PzWj",
    code: "MINE HTONE",
    short: {
      en: "MAHTANA",
      mm: "\u1019\u1011\u1014"
    },
    name: {
      en: "MINE HTONE",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1011\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "lx1vTOGIeFoZCD5a",
    code: "PAN LAUNG",
    short: {
      en: "PALAHTA",
      mm: "\u1015\u101C\u1011"
    },
    name: {
      en: "PAN LONG",
      mm: "\u1015\u1014\u103A\u101C\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "eTGyff_a8h-bDxb4",
    code: "TONETAR",
    short: {
      en: "TATANA",
      mm: "\u1010\u1010\u1014"
    },
    name: {
      en: "TONE TAR",
      mm: "\u1010\u102F\u1014\u103A\u1010\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "oECwG4VQz8QTGRPL",
    code: "MINE YAUNG",
    short: {
      en: "MAYAHTA",
      mm: "\u1019\u101A\u1011"
    },
    name: {
      en: "MINE YAUNG",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101A\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "nWJTiPaOvya2fdfd",
    code: "MANKAN",
    short: {
      en: "MAKAHTA",
      mm: "\u1019\u1000\u1011"
    },
    name: {
      en: "MANKAN",
      mm: "\u1019\u1014\u1039\u1000\u1014\u1039"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "mooTznEddVE3oyEa",
    code: "KUNLON",
    short: {
      en: "KALATA",
      mm: "\u1000\u101C\u1010"
    },
    name: {
      en: "KUN LON",
      mm: "\u1000\u103D\u1019\u103A\u1038\u101C\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "MaerUsWhYIwAWyFG",
    code: "LAUKINE",
    short: {
      en: "LAKANA",
      mm: "\u101C\u1000\u1014"
    },
    name: {
      en: "LAU KINE",
      mm: "\u101C\u1031\u102C\u1000\u103A\u1000\u102D\u102F\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "YgL1aw4MpTPyWVMy",
    code: "TACHILEIK",
    short: {
      en: "TAKHALA",
      mm: "\u1010\u1001\u101C"
    },
    name: {
      en: "TA CHI LEIK",
      mm: "\u1010\u102C\u1001\u103B\u102E\u101C\u102D\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "unoGo4FBiB9-Kupc",
    code: "KUTKAI",
    short: {
      en: "KAKHANA",
      mm: "\u1000\u1001\u1014"
    },
    name: {
      en: "KUT KAI",
      mm: "\u1000\u103D\u1000\u103A\u1001\u102D\u102F\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "rnpk9R0BhAPA9Y-r",
    code: "MINEKOKE",
    short: {
      en: "MAKANA",
      mm: "\u1019\u1000\u1014"
    },
    name: {
      en: "MINE KOKE",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1000\u1031\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "eZJrP4m1KTo9yOTe",
    code: "KEHSI",
    short: {
      en: "KATHANA",
      mm: "\u1000\u101E\u1014"
    },
    name: {
      en: "KEHSI",
      mm: "\u1000\u103B\u1031\u1038\u101E\u102E"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "nRdydABz957Vidfn",
    code: "HOMANE",
    short: {
      en: "HAMANA",
      mm: "\u101F\u1019\u1014"
    },
    name: {
      en: "HO MANE",
      mm: "\u101F\u102D\u102F\u1019\u102D\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Slv-0GjHKCJXG34f",
    code: "MONEKOE",
    short: {
      en: "MAKATA",
      mm: "\u1019\u1000\u1010"
    },
    name: {
      en: "MONE KOE",
      mm: "\u1019\u102F\u1014\u103A\u1038\u1000\u102D\u102F\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "3S_I9rN7DzNAADdc",
    code: "NANHSAM-NORTH",
    short: {
      en: "NAHSANA",
      mm: "\u1014\u1006\u1014"
    },
    name: {
      en: "NANHSAM-NORTH",
      mm: "\u1014\u1019\u1037\u103A\u1006\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "pELariH_u43L5iCj",
    code: "PINDAYA",
    short: {
      en: "PATAYA",
      mm: "\u1015\u1010\u101A"
    },
    name: {
      en: "PIN DA YA",
      mm: "\u1015\u1004\u103A\u1038\u1010\u101A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "R3jmS07-FcUCBEgH",
    code: "LECHAR",
    short: {
      en: "LAKHANA",
      mm: "\u101C\u1001\u1014"
    },
    name: {
      en: "LE CHAR",
      mm: "\u101C\u1032\u1001\u103B\u102C\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "qL9Y9sl2S86xVVLy",
    code: "NAMKHAM",
    short: {
      en: "NAKHANA",
      mm: "\u1014\u1001\u1014"
    },
    name: {
      en: "NAM KHAM",
      mm: "\u1014\u1014\u1037\u103A\u1001\u1019\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "zqy8NN6yZS5tp924",
    code: "MINEMAW",
    short: {
      en: "MAMAHTA",
      mm: "\u1019\u1019\u1011"
    },
    name: {
      en: "MINE MAW",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1019\u1031\u102C"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "2d0Kj2a4ZhRnmwlo",
    code: "MINEYAUNG",
    short: {
      en: "MAYATA",
      mm: "\u1019\u101A\u1010"
    },
    name: {
      en: "MINE YAUNG",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101A\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "YBcxm7JXP86eKVHD",
    code: "HOPAN",
    short: {
      en: "HAPATA",
      mm: "\u101F\u1015\u1010"
    },
    name: {
      en: "HO PAN",
      mm: "\u101F\u102D\u102F\u1015\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "HkXF3uhqwdCB2Hc-",
    code: "PANLON",
    short: {
      en: "PALATA",
      mm: "\u1015\u101C\u1010"
    },
    name: {
      en: "PAN LON",
      mm: "\u1015\u1014\u103A\u1038\u101C\u1031\u102C\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "RODwSIYll3IMW1ot",
    code: "PANWINE",
    short: {
      en: "PAWANA",
      mm: "\u1015\u101D\u1014"
    },
    name: {
      en: "PAN WINE",
      mm: "\u1015\u1014\u103A\u101D\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "k2fLF3uERdPmEGzB",
    code: "KENGTUNG",
    short: {
      en: "KATANA",
      mm: "\u1000\u1010\u1014"
    },
    name: {
      en: "KENG TUNG",
      mm: "\u1000\u103B\u102D\u102F\u1004\u103A\u1038\u1010\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Sqt3pTF5ARckJPHS",
    code: "MINEKAT",
    short: {
      en: "MAKHANA",
      mm: "\u1019\u1001\u1014"
    },
    name: {
      en: "MINE KAT",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1001\u1015\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "J4kYY2Is7zc1UE0X",
    code: "MINELAR",
    short: {
      en: "MALANA",
      mm: "\u1019\u101C\u1014"
    },
    name: {
      en: "MINE LAR",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101C\u102C\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "b70YGTl0IGSXlK0H",
    code: "HSIPAW",
    short: {
      en: "THAPANA",
      mm: "\u101E\u1015\u1014"
    },
    name: {
      en: "HSI PAW",
      mm: "\u101E\u102E\u1015\u1031\u102B"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "ra3h1Z2QG3-az8lD",
    code: "KYAUKME",
    short: {
      en: "KAMANA",
      mm: "\u1000\u1019\u1014"
    },
    name: {
      en: "KYAUK ME",
      mm: "\u1000\u103B\u1031\u102C\u1000\u103A\u1019\u1032"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "j1i36EwOuqicUllI",
    code: "MABANE",
    short: {
      en: "MABANA",
      mm: "\u1019\u1018\u1014"
    },
    name: {
      en: "MA BANE",
      mm: "\u1019\u1018\u102D\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "pSlRHT5xmI33LctC",
    code: "MINELON",
    short: {
      en: "MALATA",
      mm: "\u1019\u101C\u1010"
    },
    name: {
      en: "MINE LON",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101C\u102F\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "l85EqD3xGZCq01q9",
    code: "MINENGAW",
    short: {
      en: "MANGANA",
      mm: "\u1019\u1004\u1014"
    },
    name: {
      en: "MINE NGAW",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1004\u1031\u102B"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "ierX9yzC3nDJxnwb",
    code: "MOMEIK",
    short: {
      en: "MAMATA",
      mm: "\u1019\u1019\u1010"
    },
    name: {
      en: "MO MEIK",
      mm: "\u1019\u102D\u102F\u1038\u1019\u102D\u1010\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "lzbJIXlZ1qTOz-O4",
    code: "NAMTU",
    short: {
      en: "NAMATA",
      mm: "\u1014\u1019\u1010"
    },
    name: {
      en: "NA M TU",
      mm: "\u1014\u1019\u1039\u1019\u1010\u1030"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "4rgnjqkaCMYRGt_-",
    code: "NAUNGKHIO",
    short: {
      en: "NAKHATA",
      mm: "\u1014\u1001\u1010"
    },
    name: {
      en: "NAUNG KHIO",
      mm: "\u1014\u1031\u102C\u1004\u103A\u1001\u103B\u102D\u102F"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "nDtuyKgcOizNAEGv",
    code: "LASHIO",
    short: {
      en: "LAYANA",
      mm: "\u101C\u101B\u1014"
    },
    name: {
      en: "LASHIO",
      mm: "\u101C\u102C\u1038\u101B\u103E\u102D\u102F\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Ece5M61rFgFKKXCf",
    code: "TANTYAN",
    short: {
      en: "TAYANA",
      mm: "\u1010\u101A\u1014"
    },
    name: {
      en: "TANTYAN",
      mm: "\u1010\u1014\u1037\u103A\u101A\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "QHtZNDsv8GoGNlxF",
    code: "THEINNI",
    short: {
      en: "THANANA",
      mm: "\u101E\u1014\u1014"
    },
    name: {
      en: "THEIN NI",
      mm: "\u101E\u102D\u1014\u1039\u1014\u102E"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "kNzKQzngDxzc_g4n",
    code: "KONGYAN",
    short: {
      en: "KAKANA",
      mm: "\u1000\u1000\u1014"
    },
    name: {
      en: "KON GYAN",
      mm: "\u1000\u103D\u1019\u103A\u1038\u101A\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "dednit0-iOqBoGwN",
    code: "LINKHE",
    short: {
      en: "LAKHATA",
      mm: "\u101C\u1001\u1010"
    },
    name: {
      en: "LIN KHE",
      mm: "\u101C\u1004\u103A\u1001\u1031\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "kcpYBbyP4ahFBikz",
    code: "MINEPAN",
    short: {
      en: "MAPANA",
      mm: "\u1019\u1015\u1014"
    },
    name: {
      en: "MINEPAN",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1015\u1014\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "N9hZ4B1JjHnHU3NM",
    code: "MONE",
    short: {
      en: "MANANA",
      mm: "\u1019\u1014\u1014"
    },
    name: {
      en: "MONE",
      mm: "\u1019\u102D\u102F\u1038\u1014\u1032"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "B1SVY8koTJ_VlCEU",
    code: "KUNHING",
    short: {
      en: "KAHANA",
      mm: "\u1000\u101F\u1014"
    },
    name: {
      en: "KUN HING",
      mm: "\u1000\u103D\u1014\u103A\u101F\u102D\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "gjt-eUneXWMpIgQc",
    code: "LOILIN",
    short: {
      en: "LALANA",
      mm: "\u101C\u101C\u1014"
    },
    name: {
      en: "LOILIN",
      mm: "\u101C\u103D\u102D\u102F\u1004\u103A\u101C\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "aFcAdCmjZ-bKvmVz",
    code: "MINENAUNG",
    short: {
      en: "MANATA",
      mm: "\u1019\u1014\u1014"
    },
    name: {
      en: "MINE NAUNG",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1014\u1031\u102C\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "88OdT1frFeY7_ZUA",
    code: "MANKHAN",
    short: {
      en: "MAKHANA",
      mm: "\u1019\u1001\u1014"
    },
    name: {
      en: "MAN KHAN",
      mm: "\u1019\u1014\u103A\u1038\u1001\u1019\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "U0_ur1lIzWjV2ADv",
    code: "MANPHANT",
    short: {
      en: "MAPHATA",
      mm: "\u1019\u1016\u1010"
    },
    name: {
      en: "MAN PHANT",
      mm: "\u1019\u1014\u103A\u1016\u1014\u103A\u1037"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "lqjtOzS5Z4GJ4pa0",
    code: "MONGKAI",
    short: {
      en: "MAKHANA",
      mm: "\u1019\u1001\u1014"
    },
    name: {
      en: "MONG KAI",
      mm: "\u1019\u1031\u102C\u1000\u103A\u1001\u102D\u102F\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "jpN7zRVJuIl3V541",
    code: "NANHSAM-SOUTH",
    short: {
      en: "NASANA",
      mm: "\u1014\u1005\u1014"
    },
    name: {
      en: "NANHSAM-SOUTH",
      mm: "\u1014\u1019\u103A\u1037\u1005\u1014\u103A(\u1010\u1031\u102C\u1004\u103A)"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "z1kCmRwK-olJAdV6",
    code: "MAKMAN",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MAK MAN",
      mm: "\u1019\u1000\u103A\u1019\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "_tjiuRhWdmL-sXgd",
    code: "PANSAN-PANKHAM",
    short: {
      en: "PASANA",
      mm: "\u1015\u1006\u1014"
    },
    name: {
      en: "PANSAN-PANKHAM",
      mm: "\u1015\u1014\u103A\u1006\u1014\u103A\u1038(PanKham)"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "eHqpnYz0-u1E0vTI",
    code: "MINEYU",
    short: {
      en: "-",
      mm: "-"
    },
    name: {
      en: "MINE YU",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101A\u102F"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "AfESFXWJjB9FH6Ot",
    code: "MINEPYIN",
    short: {
      en: "MAPATA",
      mm: "\u1019\u1015\u1010"
    },
    name: {
      en: "MINE PYIN",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u1015\u103B\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "KEVqGlyQX-V6w8vd",
    code: "PONPARKYIN",
    short: {
      en: "PAPAKA",
      mm: "\u1015\u1015\u1000"
    },
    name: {
      en: "PON PAR KYIN",
      mm: "\u1015\u102F\u1036\u1015\u102B\u1000\u103B\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "O3TrQxAaV4sFFEAT",
    code: "MANHERO",
    short: {
      en: "MAHAYA",
      mm: "\u1019\u101F\u101B"
    },
    name: {
      en: "MAN HE RO",
      mm: "\u1019\u101F\u102E\u101B\u102D\u102F\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "B388bH0vLz1CVtdj",
    code: "MUSE",
    short: {
      en: "MASATA",
      mm: "\u1019\u1006\u1010"
    },
    name: {
      en: "MUSE",
      mm: "\u1019\u1030\u1006\u101A\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "laKI-DMGrxAcWtVc",
    code: "PANSAI",
    short: {
      en: "PASATA",
      mm: "\u1015\u1006\u1010"
    },
    name: {
      en: "PANSAI(KYU KUTE)",
      mm: "\u1015\u1014\u103A\u1006\u102D\u102F\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "aIiMGptnH6-xT3YV",
    code: "TAMOENYE",
    short: {
      en: "TAMANYA",
      mm: "\u1010\u1019\u100A"
    },
    name: {
      en: "TA MOE NYE",
      mm: "\u1010\u102C\u1019\u102D\u102F\u1038\u100A\u1032"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "0Xgb-3ZA7UXd5py7",
    code: "KENGLAT",
    short: {
      en: "KALAHTA",
      mm: "\u1000\u101C\u1011"
    },
    name: {
      en: "KENG LAT",
      mm: "\u1000\u103B\u102D\u102F\u1004\u103A\u1038\u101C\u1015\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "jVEitq7luKsmFbW0",
    code: "HOPON",
    short: {
      en: "HAPANA",
      mm: "\u101F\u1015\u1014"
    },
    name: {
      en: "HO PON",
      mm: "\u101F\u102D\u102F\u1015\u102F\u1014\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "UIeRzGItYbDwevv2",
    code: "HSIHSENG",
    short: {
      en: "SASANA",
      mm: "\u1006\u1006\u1014"
    },
    name: {
      en: "HSI HSENG",
      mm: "\u1006\u102E\u1006\u102D\u102F\u1004\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "cKrCIIk-xBHBHm9l",
    code: "INDAW-SHAN",
    short: {
      en: "AHTANA",
      mm: "\u1021\u1010\u1014"
    },
    name: {
      en: "IN DAW-SHAN",
      mm: "\u1021\u1004\u103A\u1038\u1010\u1031\u102C\u103A"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "DIX4SD_4SgwVW5dI",
    code: "NAUNGTAYAR",
    short: {
      en: "NATAYA",
      mm: "\u1014\u1010\u101B"
    },
    name: {
      en: "NAUNG TA YAR",
      mm: "\u1014\u1031\u102C\u1004\u103A\u1010\u101B\u102C\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "pPt0PjH7VcpXEW8V",
    code: "NYAUNGSHWE",
    short: {
      en: "NYAYANA",
      mm: "\u100A\u101B\u1014"
    },
    name: {
      en: "NYAUNG SHWE",
      mm: "\u100A\u1031\u102C\u1004\u103A\u101B\u103D\u103E\u1031"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "cyl1wyyPSjVlUYxj",
    code: "PINLAUNG",
    short: {
      en: "PALATA",
      mm: "\u1015\u101C\u1014"
    },
    name: {
      en: "PIN LAUNG",
      mm: "\u1015\u1004\u103A\u101C\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "ryEwHwXSMDy_IdxI",
    code: "TAUNGGYI",
    short: {
      en: "TAKANA",
      mm: "\u1010\u1000\u1014"
    },
    name: {
      en: "TAUNGGYI",
      mm: "\u1010\u1031\u102C\u1004\u103A\u1000\u103C\u102E\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "o5Prz-0-THjK0Bdi",
    code: "YWARNGAN",
    short: {
      en: "YANGANA",
      mm: "\u101B\u1004\u1014"
    },
    name: {
      en: "YWARNGAN",
      mm: "\u101B\u103D\u102C\u1004\u1036"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "kIt1DulFzNwO0yGA",
    code: "MINESHU",
    short: {
      en: "MAYANA",
      mm: "\u1019\u101B\u1014"
    },
    name: {
      en: "MINESHU",
      mm: "\u1019\u102D\u102F\u1004\u103A\u1038\u101B\u103E\u1030\u1038"
    },
    stateId: "DZ1kOrvrt-7LntG4",
    stateCode: "13"
  },
  {
    id: "Ab7FuIcZfrXWiHGd",
    code: "KYONPYAW",
    short: {
      en: "KAPANA",
      mm: "\u1000\u1015\u1014"
    },
    name: {
      en: "KYON PYAW",
      mm: "\u1000\u103B\u102F\u1036\u1015\u103B\u1031\u102C\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "K0N4SNKcHRXDqv3W",
    code: "PHYAPON",
    short: {
      en: "PHAPANA",
      mm: "\u1016\u1015\u1014"
    },
    name: {
      en: "PHYA PON",
      mm: "\u1016\u103B\u102C\u1015\u102F\u1036"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "UbriNmK5yZsZbYQ4",
    code: "PANTANAW",
    short: {
      en: "PATANA",
      mm: "\u1015\u1010\u1014"
    },
    name: {
      en: "PAN TA NAW",
      mm: "\u1015\u1014\u103A\u1038\u1010\u1014\u1031\u102C\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "ZQe21g4ADRB6MaKe",
    code: "EINME",
    short: {
      en: "AHMANA",
      mm: "\u1021\u1019\u1014"
    },
    name: {
      en: "EIN ME",
      mm: "\u1021\u102D\u1019\u103A\u1019\u1032"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "wvzMEKQOxq50JY1l",
    code: "MYANAUNG",
    short: {
      en: "MAAHNA",
      mm: "\u1019\u1021\u1014"
    },
    name: {
      en: "MYAN AUNG",
      mm: "\u1019\u103C\u1014\u103A\u1021\u1031\u102C\u1004\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "7JX4ZccciV6zDWkR",
    code: "NYAUNGDON",
    short: {
      en: "NYATANA",
      mm: "\u100A\u1010\u1014"
    },
    name: {
      en: "NYAUNG DON",
      mm: "\u100A\u1031\u102C\u1004\u103A\u1010\u102F\u1014\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "a8wWxb40G5ZDA-VC",
    code: "HAINGGYIKYUN",
    short: {
      en: "HAKAKA",
      mm: "\u101F\u1000\u1000"
    },
    name: {
      en: "HAING GYI KYUN",
      mm: "\u101F\u102D\u102F\u1004\u103A\u1038\u1000\u103C\u102E\u1038\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "rH7Ghi6WK5zoqttp",
    code: "SHWETHAUNGYAN",
    short: {
      en: "YATHAYA",
      mm: "\u101A\u101E\u101B"
    },
    name: {
      en: "SHWE THAUNG YAN",
      mm: "\u101B\u103D\u103E\u1031\u101E\u1031\u102C\u1004\u103A\u101B\u1036"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "WmmhEU1dRkL3pQxt",
    code: "NGATHAINGCHAUNG",
    short: {
      en: "NGATHAKHA",
      mm: "\u1004\u101E\u1001"
    },
    name: {
      en: "NGA THAING CHAUNG",
      mm: "\u1004\u102B\u1038\u101E\u102D\u102F\u1004\u103A\u1038\u1001\u103B\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "aDlGvhYqduAkruBx",
    code: "PATHEIN-EAST",
    short: {
      en: "PATHAYA",
      mm: "\u1015\u101E\u101B"
    },
    name: {
      en: "PATHEIN-EAST",
      mm: "\u1015\u102F\u101E\u102D\u1019\u103A (\u101B\u103E\u1031)"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "aIaA4eYkpE1ecbGP",
    code: "THAPAUNG",
    short: {
      en: "THAPANA",
      mm: "\u101E\u1015\u1014"
    },
    name: {
      en: "THA PAUNG",
      mm: "\u101E\u102C\u1015\u1031\u102B\u1004\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "iz2PhBsjJYP6xaHv",
    code: "BOGALE",
    short: {
      en: "BAKALA",
      mm: "\u1018\u1000\u101C"
    },
    name: {
      en: "BO GA LE",
      mm: "\u1018\u102D\u102F\u1000\u101C\u1031\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "AQH3JPy1jpI9TGmf",
    code: "DANUBYU",
    short: {
      en: "DANAPHA",
      mm: "\u1013\u1014\u1016"
    },
    name: {
      en: "DA NU BYU",
      mm: "\u1013\u1014\u102F\u1016\u103C\u1030"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "D70HlmKCJbNik2t-",
    code: "PYINSALU",
    short: {
      en: "PASALA",
      mm: "\u1015\u1005\u101C"
    },
    name: {
      en: "PYIN SA LU",
      mm: "\u1015\u103C\u1004\u103A\u1005\u101C\u1030"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "NwuSiiRdMeQBNoSd",
    code: "LAYMYETHNA",
    short: {
      en: "LAMANA",
      mm: "\u101C\u1019\u1014"
    },
    name: {
      en: "LAY MYETH NA",
      mm: "\u101C\u1031\u1038\u1019\u103B\u1000\u103A\u1014\u103E\u102C"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "BNwktzJgqsYgE-EX",
    code: "INGAPU",
    short: {
      en: "AHGAPA",
      mm: "\u1021\u1002\u1015"
    },
    name: {
      en: "IN GA PU",
      mm: "\u1021\u1004\u103A\u1039\u1002\u1015\u1030"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "jTbmp8sDBAaWcPK8",
    code: "NGAYOKAUNG",
    short: {
      en: "NGAYAKA",
      mm: "\u1004\u101B\u1000"
    },
    name: {
      en: "NGAYOKAUNG",
      mm: "\u1004\u101B\u102F\u1010\u103A\u1000\u1031\u102C\u1004\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "64Zu79fXerHjTxd3",
    code: "NGWEHSAUNG",
    short: {
      en: "NGASANA",
      mm: "\u1004\u1006\u1014"
    },
    name: {
      en: "NGWE HSAUNG",
      mm: "\u1004\u103D\u1031\u1006\u1031\u102C\u1004\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "qkzTGwQT2rfAQQOD",
    code: "LABUTTA",
    short: {
      en: "LAPATA",
      mm: "\u101C\u1015\u1010"
    },
    name: {
      en: "LA BUT TA",
      mm: "\u101C\u1015\u1010\u1039\u1010\u102C"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "KPXskF8LqhGQyuKS",
    code: "MYAUNGMYA",
    short: {
      en: "MAMANA",
      mm: "\u1019\u1019\u1014"
    },
    name: {
      en: "MYAUNGMYA",
      mm: "\u1019\u103C\u1031\u102C\u1004\u103A\u1038\u1019\u103C"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "HOTw3HGTLPJTjqFF",
    code: "PATHEIN",
    short: {
      en: "PATHAAH",
      mm: "\u1015\u101E\u1021"
    },
    name: {
      en: "PA THEIN (WEST)",
      mm: "\u1015\u102F\u101E\u102D\u1019\u103A (\u1014\u1031\u102C\u1000\u103A)"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "WjP5qEs2AU2jA0CZ",
    code: "PA THEIN",
    short: {
      en: "PATHANA",
      mm: "\u1015\u101E\u1014"
    },
    name: {
      en: "PATHEIN (WEST)",
      mm: "\u1015\u102F\u101E\u102D\u1019\u103A (\u1014\u1031\u102C\u1000\u103A)"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "7sqTxJkg-TkWPFLs",
    code: "MAWLAMYINEGYUN",
    short: {
      en: "MAMAKA",
      mm: "\u1019\u1019\u1000"
    },
    name: {
      en: "MAWLAMYINEGYUN",
      mm: "\u1019\u1031\u102C\u103A\u101C\u1019\u103C\u102D\u102F\u1004\u103A\u1000\u103B\u103D\u1014\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "swkP4WRf5tybANvo",
    code: "KYANGIN",
    short: {
      en: "KAKHANA",
      mm: "\u1000\u1001\u1014"
    },
    name: {
      en: "KYANGIN",
      mm: "\u1000\u103C\u1036\u1001\u1004\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "LLpvarQOCUThEvfM",
    code: "KANGYIDAUNT",
    short: {
      en: "KAKAHTA",
      mm: "\u1000\u1000\u1011"
    },
    name: {
      en: "KAN GYI DAUNT",
      mm: "\u1000\u1014\u103A\u1000\u103C\u102E\u1038\u1011\u1031\u102C\u1004\u1037\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "TUcHyp5hpaPKO1gt",
    code: "KYAIKLATT",
    short: {
      en: "KALANA",
      mm: "\u1000\u101C\u1014"
    },
    name: {
      en: "KYAIK LATT",
      mm: "\u1000\u103B\u102D\u102F\u1000\u103A\u101C\u1010\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "ZBs1WX30e9AKSsKJ",
    code: "NGAPUTAW",
    short: {
      en: "NGAPATA",
      mm: "\u1004\u1015\u1010"
    },
    name: {
      en: "NGA PU TAW",
      mm: "\u1004\u1015\u102F\u1010\u1031\u102C"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "GTsWmvoHBV1h85ze",
    code: "MAUBIN",
    short: {
      en: "MAAHPA",
      mm: "\u1019\u1021\u1015"
    },
    name: {
      en: "MA U BIN",
      mm: "\u1019\u1021\u1030\u1015\u1004\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "0Xv6T6JQvZ-4b2FO",
    code: "AHMAR",
    short: {
      en: "AHMATA",
      mm: "\u1021\u1019\u1010"
    },
    name: {
      en: "AHMAR",
      mm: "\u1021\u1019\u102C"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "-K5Ef1xBBAT-Bd2w",
    code: "HINTHADA",
    short: {
      en: "HATHATA",
      mm: "\u101F\u101E\u1010"
    },
    name: {
      en: "HIN THA DA",
      mm: "\u101F\u1004\u103A\u1039\u101E\u102C\u1010"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "g2Dh7U-i282vKhhP",
    code: "YEKYI",
    short: {
      en: "YAKANA",
      mm: "\u101B\u1000\u1014"
    },
    name: {
      en: "YE KYI",
      mm: "\u101B\u1031\u1000\u103C\u100A\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "a_ok3tGqSgyQkgNS",
    code: "KYAUNGON",
    short: {
      en: "KAKANA",
      mm: "\u1000\u1000\u1014"
    },
    name: {
      en: "KYAUN GON",
      mm: "\u1000\u103B\u1031\u102C\u1004\u103A\u1038\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "hGg3Ri7H8khZhbFA",
    code: "DAYDAYE",
    short: {
      en: "DADAYA",
      mm: "\u1012\u1012\u101B"
    },
    name: {
      en: "DAY DA YE",
      mm: "\u1012\u1031\u1038\u1012\u101B\u1032"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "Ak5C9FdDqxK6mgcO",
    code: "WAKEMA",
    short: {
      en: "WAKHAMA",
      mm: "\u101D\u1001\u1019"
    },
    name: {
      en: "WA KE MA",
      mm: "\u101D\u102B\u1038\u1001\u101A\u103A\u1019"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "TAXjsCe80RKje4sL",
    code: "ZALUN",
    short: {
      en: "ZALANA",
      mm: "\u1007\u101C\u1014"
    },
    name: {
      en: "ZA LUN",
      mm: "\u1007\u101C\u103D\u1014\u103A"
    },
    stateId: "tY793VdREy9r5xsl",
    stateCode: "14"
  },
  {
    id: "XwJyeh9PqfqFUWph",
    code: "ZABUTHIRI",
    short: {
      en: "ZABATHA",
      mm: "\u1007\u1017\u101E"
    },
    name: {
      en: "ZA BU THIRI",
      mm: "\u1007\u1019\u1039\u1017\u1030\u101E\u102E\u101B\u102D"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "eemLfSEjOBUT4vDW",
    code: "OTTARATHIRI",
    short: {
      en: "AUTATHA",
      mm: "\u1025\u1010\u101E"
    },
    name: {
      en: "OT TA RA THIRI",
      mm: "\u1025\u1010\u1039\u1010\u101B\u101E\u102E\u101B\u102D"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "SJ7t8nydl2BLXCcj",
    code: "POBBATHIRI",
    short: {
      en: "PABATHA",
      mm: "\u1015\u1017\u101E"
    },
    name: {
      en: "POB BA THIRI",
      mm: "\u1015\u102F\u1017\u1039\u1017\u101E\u102E\u101B\u102D"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "EumzaX6wjlH3WIOw",
    code: "TATKON",
    short: {
      en: "TAKANA",
      mm: "\u1010\u1000\u1014"
    },
    name: {
      en: "TATKON",
      mm: "\u1010\u1015\u103A\u1000\u102F\u1014\u103A\u1038"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "iX6euzn6oYZnxucC",
    code: "DEKKHINATHIRI",
    short: {
      en: "DAKHATHA",
      mm: "\u1012\u1001\u101E"
    },
    name: {
      en: "DEK KHI NA THIRI",
      mm: "\u1012\u1000\u1039\u1001\u102D\u100F\u101E\u102E\u101B\u102D"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "UcyG-TtduU0p1TNY",
    code: "LEWE",
    short: {
      en: "LAWANA",
      mm: "\u101C\u101D\u1014"
    },
    name: {
      en: "LEWE",
      mm: "\u101C\u101A\u103A\u101D\u1031\u1038"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "mhOAOvw2SqGAycTf",
    code: "PYINMANA",
    short: {
      en: "PAMANA",
      mm: "\u1015\u1019\u1014"
    },
    name: {
      en: "PYIN MA NA",
      mm: "\u1015\u103B\u1009\u103A\u1038\u1019\u1014\u102C\u1038"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  },
  {
    id: "AEdvbbm5rI4jOAoi",
    code: "ZEYARTHIRI",
    short: {
      en: "ZAYATHA",
      mm: "\u1007\u101A\u101E"
    },
    name: {
      en: "ZE YAR THIRI",
      mm: "\u1007\u1031\u101A\u103B\u102C\u101E\u102E\u101B\u102D"
    },
    stateId: "sH0ybsmxNuxmeOT_",
    stateCode: "9*"
  }
];
var NRCData = {
  nrcTypes: nrcTypes$1,
  nrcStates: nrcStates$1,
  nrcTownships
};
function getNrcData() {
  return NRCData;
}
function getNrcStates() {
  return NRCData.nrcStates;
}
function getNrcTownships() {
  return NRCData.nrcTownships;
}
function getNrcTypes() {
  return NRCData.nrcTypes;
}
function getNrcStateById(id) {
  return NRCData.nrcStates.find((state) => state.id === id);
}
function getNrcTownshipById(id) {
  return NRCData.nrcTownships.find((township) => township.id === id);
}
function getNrcTypeById(id) {
  return NRCData.nrcTypes.find((type) => type.id === id);
}
function getNrcTownshipsByStateId(stateId) {
  return NRCData.nrcTownships.filter((township) => township.stateId === stateId);
}
const nrcStates = getNrcStates();
const nrcTypes = getNrcTypes();
function convertToMmNrc(engNrc) {
  var _a, _b;
  if (!pattern.en.test(engNrc))
    throw new Error("Invalid english NRC format.");
  const { nrcNumber, nrcType, stateNo, townshipCode } = splitNrc(engNrc);
  const state = nrcStates.find((nState) => nState.number.en === stateNo);
  const stateMm = state ? state.number.mm : stateNo;
  const townshipMm = ((_a = getNrcTownshipsByStateId((state == null ? void 0 : state.id) || "").find((nTownship) => nTownship.short.en === townshipCode)) == null ? void 0 : _a.short.mm) || townshipCode;
  const typeMm = ((_b = nrcTypes.find((nType) => nType.name.en === nrcType)) == null ? void 0 : _b.name.mm) || nrcType;
  return `${stateMm}/${townshipMm}(${typeMm})${nrcNumber}`;
}
function convertToEnNrc(mmNrc) {
  var _a, _b;
  if (!pattern.mm.test(mmNrc))
    throw new Error("Invalid myanmar NRC format.");
  const { nrcNumber, nrcType, stateNo, townshipCode } = splitNrc(mmNrc);
  const state = nrcStates.find((nState) => nState.number.mm === stateNo);
  const stateEn = state ? state.number.en : stateNo;
  const townshipEn = ((_a = getNrcTownshipsByStateId((state == null ? void 0 : state.id) || "").find((nTownship) => nTownship.short.mm === townshipCode)) == null ? void 0 : _a.short.en) || townshipCode;
  const typeEn = ((_b = nrcTypes.find((nType) => nType.name.mm === nrcType)) == null ? void 0 : _b.name.en) || nrcType;
  return `${stateEn}/${townshipEn}(${typeEn})${nrcNumber}`;
}
export { convertToEnNrc, convertToMmNrc, getNrcData, getNrcStateById, getNrcStates, getNrcTownshipById, getNrcTownships, getNrcTownshipsByStateId, getNrcTypeById, getNrcTypes, pattern, splitNrc };
